<template>
  <div class="bill-info">
    <KTCodePreview v-bind:title="''">
      <template v-slot:preview>
        <b-card no-body class="full-width">
          <div>
            <div class="wizard-nav-bg">
              <b-col
                class="py-2"
                cols="12"
                style="border-bottom: 0.5px solid #e7e7e7"
              >
                <b-row>
                  <b-col
                    ><b>{{ pageTitle ? pageTitle : '#' }}</b>
                  </b-col>
                  <b-col>
                    <div class="d-flex justify-content-end mr-3">
                      <template v-if="shiftWorkConfig">
                        <b-button-group
                          v-if="shiftWorkConfig && mainModel.editable"
                          class="font-weight-bold ml-3"
                        >
                          <b-button
                            v-b-tooltip.hover
                            title="Chọn nhân viên theo cấu hình theo ca làm việc"
                            @click="onShiftWorkConfigSelected"
                            >{{ shiftWorkConfig.name }}
                          </b-button>
                          <b-button
                            @click="showModalShiftWorkConfig"
                            v-b-modal.modal-upsert-shiftWork
                          >
                            <i class="fa fa-cog font-size-md"></i>
                          </b-button>
                        </b-button-group>
                      </template>
                      <b-button
                        v-else
                        @click="showModalShiftWorkConfig"
                        v-b-modal.modal-upsert-shiftWork
                      >
                        Cấu hình ca làm việc
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </div>
            <div
              class="wizard wizard-4"
              id="kt_wizard_v4_bill"
              data-wizard-state="step-first"
              data-wizard-clickable="true"
            >
              <!--begin: Wizard Nav-->
              <div class="wizard-nav wizard-nav-bg" style="border-radius: 0px">
                <div class="wizard-steps">
                  <!-- Thông tin -->
                  <div
                    class="wizard-step"
                    data-wizard-type="step"
                    data-wizard-state="current"
                  >
                    <div class="wizard-wrapper p-2">
                      <div class="wizard-label">
                        <div class="wizard-title">Thông tin</div>
                      </div>
                    </div>
                  </div>
                  <!-- Lịch sử -->
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >
                    <div class="wizard-wrapper p-2">
                      <div class="wizard-label">
                        <div class="wizard-title">Lịch sử</div>
                      </div>
                    </div>
                  </div>
                  <!-- Tệp đính kèm -->
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >
                    <div class="wizard-wrapper p-2">
                      <div class="wizard-label">
                        <div class="wizard-title">Tệp đính kèm</div>
                      </div>
                    </div>
                  </div>
                  <!-- Phiếu thu cũ -->
                  <div class="wizard-step ml-1" data-wizard-type="step">
                    <div class="wizard-wrapper p-2">
                      <div class="wizard-label">
                        <div class="wizard-title">Phiếu thu cũ</div>
                      </div>
                    </div>
                  </div>
                  <!-- Phiếu sửa chữa (M7 V2 — chỉ show khi Bill được auto-tạo từ phiếu SC) -->
                  <div
                    v-show="mainModel.repairSlipId"
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                  >
                    <div class="wizard-wrapper p-2">
                      <div class="wizard-label">
                        <div class="wizard-title">Phiếu sửa chữa</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-custom card-shadowless rounded-top-0">
                <b-skeleton-wrapper :loading="!renderComponent">
                  <template #loading>
                    <div class="card-body">
                      <b-row>
                        <b-col md="9">
                          <div class="mb-4 d-flex d-inline">
                            <b-skeleton
                              animation="wave"
                              width="18%"
                              class="mr-2"
                            ></b-skeleton>
                            <b-skeleton
                              animation="wave"
                              width="82%"
                            ></b-skeleton>
                          </div>
                          <b-skeleton-table
                            :rows="4"
                            :columns="4"
                            :table-props="{ bordered: true, striped: true }"
                          ></b-skeleton-table>
                          <b-row>
                            <b-col md="4">
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                            </b-col>
                            <b-col md="4">
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                            </b-col>
                            <b-col md="4">
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col md="3">
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                        </b-col>
                      </b-row>
                    </div>
                  </template>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-xl-12">
                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                          data-wizard-state="current"
                        >
                          <b-form ref="form" lazy-validation class="row">
                            <!-- warning -->
                            <b-row
                              class="col-md-12 mb-1 m-0 p-0"
                              v-if="mainModel.billVat"
                            >
                              <div
                                class="alert alert-dismissible bg-light-danger"
                                style="width: 100%"
                              >
                                Hóa đơn đã được tạo <strong>hóa đơn đỏ</strong>,
                                trường hợp cần chỉnh sửa
                                <strong>vui lòng liên hệ kế toán</strong>
                              </div>
                            </b-row>
                            <b-row
                              class="col-md-12 mb-1 m-0 p-0"
                              v-if="mainModel.fromBillNumber"
                            >
                              <div class="alert-header" style="width: 100%">
                                Tạo lại hóa đơn mới từ hóa đơn:
                                <span class="text-primary">{{
                                  mainModel.fromBillNumber
                                }}</span>
                              </div>
                            </b-row>
                            <b-row
                              class="col-md-12 mb-1 m-0 p-0"
                              v-if="mainModel.orderId"
                            >
                              <div class="alert-header" style="width: 100%">
                                Chuyển đơn hàng
                                <span
                                  class="text-primary"
                                  style="cursor: pointer"
                                  @click="linkToOrder(mainModel.orderId)"
                                  >{{ mainModel.orderId }}</span
                                >
                                sang hóa đơn bán lẻ .
                                <ul
                                  style="
                                    padding-left: 15px;
                                    line-height: 20px;
                                    margin-top: 5px;
                                    list-style: circle;
                                  "
                                >
                                  <li v-show="mainModel.moneyPaid > 0">
                                    Số tiền đã đặt cọc:
                                    <span class="text-primary">
                                      {{ formatMoney(mainModel.moneyPaid) }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.moneyTransfered > 0">
                                    Số tiền đã chuyển khoản:
                                    <span class="text-primary">
                                      {{
                                        formatMoney(mainModel.moneyTransfered)
                                      }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.moneyCredit > 0">
                                    Số tiền quẹt thẻ:
                                    <span class="text-primary">
                                      {{ formatMoney(mainModel.moneyCredit) }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.moneyInstallment > 0">
                                    Số tiền đã trả góp:
                                    <span class="text-primary">
                                      {{
                                        formatMoney(mainModel.moneyInstallment)
                                      }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.customerShipFee > 0">
                                    Phí ship:
                                    <span class="text-primary">
                                      {{
                                        formatMoney(mainModel.customerShipFee)
                                      }}
                                    </span>
                                  </li>
                                  <li v-show="refundMoneyFromOrder > 0">
                                    Số tiền đơn hàng đã hoàn:
                                    <span class="text-primary">
                                      {{ formatMoney(refundMoneyFromOrder) }}
                                    </span>
                                  </li>
                                </ul>
                                Mã vận đơn:
                                <span class="text-primary">
                                  {{ mainModel.codeShip }}
                                </span>
                              </div>
                            </b-row>
                            <b-row
                              class="col-md-12 mb-1 m-0 p-0"
                              v-if="
                                !mainModel.id &&
                                !mainModel.orderId &&
                                orderNotComplete
                              "
                            >
                              <div class="alert-header" style="width: 100%">
                                Khách hàng đang có đơn hàng chưa hoàn tất:
                                <span class="text-primary"
                                  >#{{ orderNotComplete.id }}</span
                                >
                                -
                                <span
                                  v-text="orderNotComplete.statusName"
                                  class="text-warning"
                                ></span>
                              </div>
                            </b-row>
                            <!-- <b-row
                              class="col-md-12 mb-1 m-0 p-0"
                              v-if="getInstallmentInterestZero"
                            >
                              <div class="alert-header" style="width: 100%">
                                <i
                                  class="fa fa-exclamation-triangle text-warning"
                                ></i>
                                <strong class="text-dark">
                                  Chuyển sang cấu hình trả góp 0%</strong
                                >
                                <span
                                  class="text-primary ml-2"
                                  style="cursor: pointer"
                                  @click="onShowInterestProgram"
                                  >Xem chương trình</span
                                >
                              </div>
                            </b-row> -->
                            <b-row class="col-md-12 mb-1 m-0 p-0">
                              <b-col md="9" class="mb-2">
                                <b-row>
                                  <b-col md="3" class="p-0">
                                    <b-form-select
                                      v-model="selectTypeSearch"
                                      class="select-style"
                                      :options="listTypeSearch"
                                      size="sm"
                                      value-field="id"
                                      text-field="name"
                                      @change="changePlaceholder"
                                    ></b-form-select>
                                  </b-col>
                                  <b-col md="9" class="p-0">
                                    <vue-autosuggest
                                      v-model="searchProduct"
                                      :suggestions="filteredOptionsProduct"
                                      @selected="onSelectedProduct"
                                      :limit="20"
                                      @input="onInputChangProduct"
                                      :input-props="inputSearchProductProp"
                                      :should-render-suggestions="
                                        (size, loading) => !loading
                                      "
                                      :get-suggestion-value="
                                        (suggestion) =>
                                          suggestion.item.productName
                                      "
                                    >
                                      <div
                                        v-if="selectTypeSearch === 1"
                                        slot-scope="{ suggestion }"
                                        style="
                                          display: flex;
                                          align-items: center;
                                        "
                                      >
                                        <div>
                                          <span
                                            v-if="getInstallmentInterestZero"
                                            class="text-warning"
                                          >
                                            (
                                            {{
                                              formatMoney(
                                                suggestion.item.listedPrice,
                                              )
                                            }}
                                            )</span
                                          >
                                          <span v-else class="text-primary"
                                            >({{
                                              formatMoney(
                                                suggestion.item.sellingPrice,
                                              )
                                            }})
                                          </span>
                                          <span
                                            v-if="
                                              suggestion.item.quantityInStock >
                                                0 &&
                                              suggestion.item.productType !== 4
                                            "
                                            class="text-success"
                                            >(Tồn CTB:
                                            {{
                                              suggestion.item.quantityInStock
                                            }})</span
                                          >
                                          <span
                                            v-if="
                                              suggestion.item.quantityInStock <=
                                                0 &&
                                              suggestion.item.productType !==
                                                PRODUCT_TYPE.PRODUCT_SERVICE &&
                                              suggestion.item.productType !==
                                                PRODUCT_TYPE.PRODUCT_WARRANTY
                                            "
                                            class="text-danger"
                                            >(Tồn CTB:
                                            {{
                                              suggestion.item.quantityInStock
                                            }})</span
                                          >
                                          {{ suggestion.item.productName }}
                                        </div>
                                      </div>
                                      <div
                                        v-else-if="selectTypeSearch === 2"
                                        slot-scope="{ suggestion }"
                                        style="
                                          display: flex;
                                          align-items: center;
                                        "
                                      >
                                        <div>
                                          <span class="text-primary"
                                            >({{
                                              formatMoney(
                                                suggestion.item.sellingPrice,
                                              )
                                            }})</span
                                          >
                                          <span
                                            v-if="
                                              suggestion.item.quantityInStock >
                                              0
                                            "
                                            class="text-success"
                                            >(Tồn CTB:
                                            {{
                                              suggestion.item.quantityInStock
                                            }})</span
                                          >
                                          {{ suggestion.item.productName }}-
                                          <span class="text-warning"
                                            >IMEI:
                                            {{ suggestion.item.imeiCode }}</span
                                          >
                                        </div>
                                      </div>
                                      <div
                                        v-else-if="selectTypeSearch === 3"
                                        slot-scope="{ suggestion }"
                                        style="
                                          display: flex;
                                          align-items: center;
                                        "
                                      >
                                        <div>
                                          <span class="text-success"
                                            >(Số SP:
                                            {{
                                              suggestion.item.listItem.length
                                            }})</span
                                          >
                                          {{ suggestion.item.productName }}
                                        </div>
                                      </div>
                                      <template slot="after-section">
                                        <div
                                          class="p-2 text-center"
                                          v-if="
                                            !filteredOptionsProduct[0].data
                                              .length
                                          "
                                        >
                                          <div v-if="!productLoading">
                                            <img
                                              src="../../../assets/image/no-results.png"
                                            />
                                            <b class="ml-2">Không có kết quả</b>
                                          </div>
                                          <b-spinner
                                            label="Spinning"
                                            v-if="productLoading"
                                          ></b-spinner>
                                        </div>
                                      </template>
                                    </vue-autosuggest>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <b-col md="3" class="mb-3 pr-0">
                                <SearchStore
                                  :onSubmiting="onSubmiting"
                                  :storeId="mainModel.storeId"
                                  :storeName.sync="mainModel.storeName"
                                  v-on:onStoreSelected="onStoreSelected"
                                  :disable="
                                    !!mainModel.id || mainModel.storeDisable
                                  "
                                  v-if="renderComponent"
                                />
                              </b-col>
                            </b-row>
                            <b-row class="mb-3 m-0 p-0">
                              <b-col md="9" class="mb-3">
                                <b-row>
                                  <table
                                    class="table table-bordered table-vertical-center table-hover"
                                  >
                                    <thead>
                                      <tr>
                                        <th class="headerTable">STT</th>
                                        <th class="name headerTable">
                                          Sản phẩm
                                        </th>
                                        <th class="value headerTable">SL</th>
                                        <th class="code headerTable">Giá</th>
                                        <th class="code headerTable">
                                          Thành tiền
                                        </th>
                                        <th class="code headerTable">
                                          Chiết khấu
                                        </th>
                                        <th class="code headerTable">VAT</th>
                                        <th></th>
                                      </tr>
                                    </thead>

                                    <tbody
                                      v-for="(item, index) in listBillItem"
                                      :key="item.id"
                                    >
                                      <BillItem
                                        v-bind:productItem="item"
                                        v-bind:listBillItem="listBillItem"
                                        v-bind:editable="mainModel.editable"
                                        v-bind:disableChangeBatch="
                                          $route.name === 'update-bill'
                                        "
                                        v-bind:productIds="selectedProductIds"
                                        v-bind:editIMEI="
                                          // !mainModel.id &&
                                          !item.imeiCode &&
                                          !mainModel.fromBillNumber
                                        "
                                        v-on:updateVoucher="
                                          reCalVoucherBillItem
                                        "
                                        v-bind:billItemIndex="index"
                                        v-bind:enableComboImei="
                                          isEnabledAttachImeiCombo
                                        "
                                        v-on:update="updateItem"
                                        v-on:deleteItem="deleteBillItem"
                                        v-on:checkValidImei="checkValidImei"
                                        v-on:addProductBonus="showGiftModal"
                                        v-on:addProductPromotion="
                                          showAttachModal
                                        "
                                        v-on:addProductWarranty="
                                          showWarrantyModal
                                        "
                                        v-on:changeProductBonus="
                                          showChangeGiftModal
                                        "
                                        v-on:addNote="showNoteModal"
                                        v-on:linkToListImei="showListImeiModal"
                                        v-on:viewInventory="viewInventory"
                                        v-on:addWarranty="linkToWarranty"
                                        v-on:activeImei="showActiveModal"
                                        v-on:addVoucher="showAddVoucherModal"
                                        @updateExternalImeiNo="
                                          setImeiNoForBelongDetailBillIds
                                        "
                                        v-on:linkToProductBatch="
                                          showListProductBatchModal
                                        "
                                        @linkToProductBatchForComboChild="
                                          showListProductBatchModalForComboChild
                                        "
                                        @updateWarrantyImeiNo="
                                          updateWarrantyImeiNo
                                        "
                                      />
                                    </tbody>
                                    <tfoot>
                                      <tr>
                                        <th
                                          style="text-align: right"
                                          id="total"
                                          colspan="5"
                                        >
                                          <span
                                            class="d-block"
                                            v-if="totalAmountBeforeDiscount"
                                            >Tổng trước chiết khấu:</span
                                          >
                                          <span class="d-block">Tổng:</span>
                                        </th>
                                        <td
                                          style="
                                            text-align: right;
                                            padding: 0px 20px;
                                          "
                                        >
                                          <span
                                            class="d-block"
                                            v-if="totalAmountBeforeDiscount"
                                          >
                                            {{
                                              formatMoney(
                                                totalAmountBeforeDiscount,
                                              )
                                            }}
                                          </span>
                                          <span class="d-block">{{
                                            formatMoney(totalAmount)
                                          }}</span>
                                        </td>
                                        <td
                                          style="
                                            text-align: right;
                                            padding: 0px 20px;
                                          "
                                        ></td>
                                        <td></td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </b-row>
                                <b-row style="margin-left: -25px">
                                  <b-col md="4">
                                    <b-form-group
                                      v-if="
                                        listBillItem.length > 0 &&
                                        isEnableSendBillMethod
                                      "
                                      label="Chọn phương thức gửi thông tin sản phẩm đối tác"
                                      class="font-weight-bold"
                                    >
                                      <b-form-radio-group
                                        id="radio-group-method-send-bill"
                                        v-model="selectedSendBillMethod"
                                        :options="sendBillMethodOptions"
                                      ></b-form-radio-group>
                                    </b-form-group>
                                    <CustomerInfo
                                      :onSubmiting="onSubmiting"
                                      :billData="mainModel"
                                      :disabled="!mainModel.editable"
                                      v-on:onUpdate="onUpdateCustomer"
                                      v-if="renderComponent"
                                      v-on:fetch-customer-transaction="
                                        fetchCustomerCransaction
                                      "
                                      v-on:fetch-discount-customer="
                                        changeDiscountComponentCustomerInfo
                                      "
                                      :isRequiredLocation="isEnableValidateCustomerInfo"
                                    />
                                    <b-form-group
                                      :disabled="!mainModel.editable"
                                    >
                                      <label>Nguồn khách hàng:</label>
                                      <b-form-select
                                        v-model="mainModel.orderSourceId"
                                        :options="listCustomerSource"
                                        size="sm"
                                        value-field="id"
                                        text-field="name"
                                        class="select-style"
                                      >
                                        <template v-slot:first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                            >Chọn nguồn khách hàng:
                                          </b-form-select-option>
                                        </template>
                                      </b-form-select>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="4">
                                    <EmployeeInfo
                                      :storeId="mainModel.storeId"
                                      :billDataEmployeeInfo="
                                        mainModel.billEmployeeInfo
                                      "
                                      :disabled="!mainModel.editable"
                                    />
                                  </b-col>
                                  <b-col md="4">
                                    <WarrantyCustomerInfo
                                      :billData="mainModel"
                                      :disabled="!mainModel.editable"
                                      v-if="renderComponent"
                                    />
                                    <BillVatInfo
                                      :isValidTaxCode.sync="isValidTaxCode"
                                      :isValidEmail.sync="isValidEmail"
                                      :billData="mainModel"
                                      :disabled="!mainModel.editable"
                                      v-if="renderComponent"
                                    />
                                  </b-col>
                                </b-row>
                                <BillNote
                                  :billNote="mainModel.billNote"
                                  :disabled="!mainModel.editable"
                                  v-if="renderComponent"
                                />
                              </b-col>
                              <b-col md="3" class="mb-3 pr-0">
                                <b-form-group
                                  :disabled="
                                    !mainModel.editable ||
                                    getInstallmentInterestZero
                                  "
                                >
                                  <label class="lable-form">Chiết khấu:</label>
                                  <b-row>
                                    <b-col class="pr-0" cols="3">
                                      <b-form-select
                                        class="select-style"
                                        v-model="mainModel.discountType"
                                        :options="listAmountType"
                                        size="sm"
                                        value-field="id"
                                        text-field="name"
                                      >
                                      </b-form-select>
                                    </b-col>
                                    <b-col class="pl-0" cols="9">
                                      <b-form-input
                                        class="input-style text-right"
                                        size="sm"
                                        v-model="mainModel.discountAmount"
                                        v-mask="mask"
                                        placeholder="Chiết khấu"
                                      ></b-form-input>
                                    </b-col>
                                  </b-row>
                                </b-form-group>
                                <b-form-group :disabled="!mainModel.editable">
                                  <label>Mã coupon:</label>
                                  <b-input-group>
                                    <b-form-input
                                      class="input-style"
                                      size="sm"
                                      type="text"
                                      v-model="mainModel.couponCode"
                                      placeholder="Nhập mã coupon"
                                      @change="changeCouponCode()"
                                      :state="stateCouponCode"
                                    ></b-form-input>
                                    <b-input-group-append>
                                      <b-button
                                        style="width: 40px"
                                        variant="secondary"
                                        size="sm"
                                        @click="checkCoupon()"
                                      >
                                        <i class="fas fa-sync"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                                <div
                                  v-if="
                                    mainModel.customerModel.customerId &&
                                    mainModel.customerModel.customerMobile &&
                                    !mainModel.isSubtractPointValidated &&
                                    isValidUseDMem
                                  "
                                >
                                  <b-form-group :disabled="!mainModel.editable">
                                    <b-row class="align-items-center">
                                      <b-col md="6">
                                        <label>Chiết khấu D-MEM:</label>
                                      </b-col>
                                      <b-col
                                        md="6"
                                        class="text-right"
                                        v-if="!isFeatureActive('hide-otp')"
                                      >
                                        <a
                                          href="javascript:void(0)"
                                          style="color: blue; font-weight: bold"
                                          @click="getOTP(OTP_DISCOUNT.D_MEM)"
                                          >Gửi mã</a
                                        >
                                      </b-col>
                                    </b-row>
                                    <b-input-group>
                                      <b-form-input
                                        class="input-style text-right"
                                        size="sm"
                                        type="text"
                                        v-model="mainModel.otpCodeDmem"
                                        placeholder="Nhập mã OTP"
                                        :state="stateOTPDmem"
                                      ></b-form-input>
                                      <b-input-group-append>
                                        <b-button
                                          style="width: 40px"
                                          variant="secondary"
                                          size="sm"
                                          @click="checkOTP(OTP_DISCOUNT.D_MEM)"
                                        >
                                          <i class="fas fa-sync"></i>
                                        </b-button>
                                      </b-input-group-append>
                                    </b-input-group>
                                  </b-form-group>
                                </div>
                                <div
                                  v-if="
                                    mainModel.customerModel.totalPoint > 0 &&
                                    !isUseDiscountDmem &&
                                    isValidUsePoint
                                  "
                                >
                                  <b-form-group
                                    :disabled="
                                      !mainModel.editable ||
                                      getInstallmentInterestZero
                                    "
                                  >
                                    <label>Tiêu điểm tích lũy:</label>
                                    <b-input-group>
                                      <b-form-input
                                        class="input-style text-right"
                                        size="sm"
                                        type="text"
                                        v-model="mainModel.subtractPoint"
                                        placeholder="Nhập số điểm"
                                        v-mask="mask"
                                        @change="onChangeSubtractPoint()"
                                      ></b-form-input>
                                      <b-input-group-append
                                        v-if="!isFeatureActive('hide-otp')"
                                      >
                                        <b-button
                                          style="width: 40px"
                                          variant="secondary"
                                          size="sm"
                                          @click="getOTP()"
                                        >
                                          <i class="fas fa-mobile-alt"></i>
                                        </b-button>
                                      </b-input-group-append>
                                    </b-input-group>
                                  </b-form-group>
                                  <b-form-group :disabled="!mainModel.editable">
                                    <label>Mã OTP:</label>
                                    <b-input-group>
                                      <b-form-input
                                        class="input-style text-right"
                                        size="sm"
                                        type="text"
                                        v-model="mainModel.otpCode"
                                        placeholder="Nhập mã OTP"
                                        :state="stateOTP"
                                      ></b-form-input>
                                      <b-input-group-append>
                                        <b-button
                                          style="width: 40px"
                                          variant="secondary"
                                          size="sm"
                                          @click="checkOTP()"
                                        >
                                          <i class="fas fa-sync"></i>
                                        </b-button>
                                      </b-input-group-append>
                                    </b-input-group>
                                  </b-form-group>
                                </div>
                                <!-- <b-row>
                                  <b-col>
                                    <b-checkbox
                                      v-model="mainModel.isCountPoint"
                                      class="mt-2 mb-2"
                                      >Tự động tích điểm
                                    </b-checkbox>
                                  </b-col>
                                </b-row> -->
                                <div class="row-center-vertical">
                                  <b-col md="6" class="no-side">
                                    <p class="textPayment">Thanh toán</p>
                                  </b-col>
                                  <b-col md="6" class="no-side">
                                    <p
                                      class="textPoint text-right"
                                      v-if="mainModel.isCountPoint"
                                    >
                                      {{ addPoint }} điểm
                                    </p>
                                  </b-col>
                                </div>
                                <b-row class="mb-1">
                                  <b-col md="6">
                                    <span class="textTitlePayment"
                                      >Tổng tiền:</span
                                    >
                                  </b-col>
                                  <b-col md="6" class="text-right">
                                    <span class="textPayment">
                                      {{ formatMoney(totalAmount) }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-row
                                  v-if="mainModel.totalAmountPoint > 0"
                                  class="mb-1"
                                >
                                  <b-col md="6">
                                    <span class="textTitlePayment"
                                      >Tiêu điểm:</span
                                    >
                                  </b-col>
                                  <b-col md="6" class="text-right">
                                    <span class="textPayment">
                                      {{
                                        formatMoney(mainModel.totalAmountPoint)
                                      }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-row
                                  v-if="totalAmountReturn > 0"
                                  class="mb-1"
                                >
                                  <b-col md="6">
                                    <span class="textTitlePayment">
                                      Tiền thu lại:
                                    </span>
                                  </b-col>
                                  <b-col md="6" class="text-right">
                                    <span class="textPayment">
                                      {{ formatMoney(totalAmountReturn) }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-row v-if="totalPaid > 0" class="mb-1">
                                  <b-col md="6">
                                    <span class="textTitlePayment">
                                      Khách đã đưa:
                                    </span>
                                  </b-col>
                                  <b-col md="6" class="text-right">
                                    <span class="textPayment">
                                      {{ formatMoney(totalPaid) }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <div v-if="getInstallmentInterestZero">
                                  <!-- <b-row>
                                    <b-col md="6">
                                      <b> Tiền trả trước: </b>
                                    </b-col>
                                    <b-col md="6">
                                      <p class="text-right textFinal">
                                        {{ formatMoney(interestZeroPrePaid) }}
                                      </p>
                                    </b-col>
                                  </b-row> -->
                                  <b-row>
                                    <b-col md="6">
                                      <b> Phí chuyển đổi: </b>
                                    </b-col>
                                    <b-col md="6">
                                      <p class="text-right textFinal">
                                        {{ formatMoney(interestZeroExchange) }}
                                      </p>
                                    </b-col>
                                  </b-row>
                                  <!-- <b-row class="mb-1">
                                    <b-col md="6">
                                      <span class="textTitlePayment">
                                        Khách cần trả trước:
                                      </span>
                                    </b-col>
                                    <b-col md="6" class="text-right">
                                      <span class="textPayment">
                                        {{
                                          formatMoney(
                                            interestZeroPrePaid +
                                              interestZeroExchange,
                                          )
                                        }}
                                      </span>
                                    </b-col>
                                  </b-row> -->
                                </div>
                                <b-row v-else class="mb-1">
                                  <b-col md="6">
                                    <span class="textTitlePayment">
                                      Khách cần trả:
                                    </span>
                                  </b-col>
                                  <b-col md="6" class="text-right">
                                    <span class="textPayment">
                                      {{ formatMoney(finalAmount) }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-row v-if="refundMoneyFromOrder" class="mb-1">
                                  <b-col md="6">
                                    <span class="textTitlePayment">
                                      Hoàn tiền đơn hàng:
                                    </span>
                                  </b-col>
                                  <b-col md="6" class="text-right">
                                    <span class="textPayment">
                                      {{ formatMoney(refundMoneyFromOrder) }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <BillPayment
                                  ref="bill-payment"
                                  :key="reRenderComponentBillPayment"
                                  v-if="renderComponent"
                                  :finalAmount="finalAmount"
                                  :billData="mainModel"
                                  :billItems="listBillItem"
                                  :onSubmiting="onPaymentSubmiting"
                                  :disabled="!mainModel.editable"
                                  :isAllowQRCode="isAllowQRCode"
                                  v-on:onUpdate="onUpdatePayment"
                                  v-on:receive-payment="onUpdatePayment"
                                  v-on:receive-payment-mul="onUpdatePaymentV2"
                                  v-on:click-generate-qrcode="onClickGenerateQR"
                                  v-on:click-checkout-kredivo="
                                    onClickCheckoutKredivo
                                  "
                                  v-on:click-check-status-kredivo="
                                    onClickCheckStatusKredivo
                                  "
                                  v-on:click-cancel-transaction-kredivo="
                                    onClickCancelTransactionKredivo
                                  "
                                  v-on:remain-amount="handleRemainAmountChanged"
                                />
                              </b-col>
                            </b-row>
                            <b-row
                              v-if="mainModel.id"
                              class="col-md-12 mb-1 m-0 p-0"
                            >
                              <b-container
                                class="p-0"
                                v-if="checkPermission('TRANSACTION_VIEW')"
                              >
                                <hr
                                  class="hr-text"
                                  data-content="Bút Toán"
                                  style="font-weight: 600"
                                />
                                <b-row>
                                  <b-col md="12" lg="12" sm="12">
                                    <BillTransactions
                                      :billNumber="$route.query.id"
                                    />
                                  </b-col>
                                </b-row>
                              </b-container>
                              <b-container
                                class="p-0"
                                v-if="checkPermission('STOCK_VIEW')"
                              >
                                <hr
                                  class="hr-text"
                                  data-content="Phiếu bảo hành"
                                  style="font-weight: 600"
                                />
                                <b-row>
                                  <b-col md="12" lg="12" sm="12">
                                    <WarrantyTransaction
                                      :billNumber="mainModel.id"
                                    />
                                  </b-col>
                                </b-row>
                              </b-container>
                            </b-row>
                            <div style="position: sticky; top: 200px">
                              <b-row>
                                <b-col>
                                  <SaveButton
                                    v-if="mainModel.editable"
                                    type="button"
                                    :button-style="{
                                      minWidth: '70px',
                                      whiteSpace: 'nowrap',
                                      marginRight: '10px',
                                    }"
                                    :is-busy="onSubmiting"
                                    :disabled="isLoading"
                                    @click="onSubmit('save')"
                                  >
                                    Lưu
                                  </SaveButton>
                                  <SaveButton
                                    v-if="mainModel.editable && mainModel.id"
                                    type="button"
                                    variant="warning"
                                    :button-style="{
                                      minWidth: '100px',
                                      whiteSpace: 'nowrap',
                                      marginRight: '10px',
                                    }"
                                    :is-busy="onSubmiting"
                                    :disabled="isLoading"
                                    @click="onSubmit('save-print')"
                                  >
                                    Lưu và in
                                  </SaveButton>
                                  <router-link
                                    to="/bills"
                                    tag="button"
                                    :style="
                                      onSubmiting ? 'pointer-events: none' : null
                                    "
                                  >
                                    <b-button
                                      tabindex="16"
                                      style="font-weight: 600; width: 70px"
                                      variant="secondary"
                                      size="sm"
                                      :disabled="onSubmiting"
                                      >Hủy
                                    </b-button>
                                  </router-link>
                                </b-col>
                              </b-row>
                            </div>
                          </b-form>
                        </div>

                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                        >
                          <b-container class="bv-example-row">
                            <b-table
                              :fields="historyFields"
                              :items="histories"
                              class="table-bordered table-hover col-md-6"
                            >
                              <template v-slot:cell(updatedBy)="row">
                                <p>{{ row.item.updatedBy }}</p>
                                <p>{{ row.item.updatedAt }}</p>
                              </template>
                              <template v-slot:cell(action)="row">
                                <p>
                                  {{ getHistoryActionLabel(row.item.action) }}
                                </p>
                              </template>
                              <template v-slot:cell(detail)="row">
                                <div
                                  class="orderCode"
                                  @click="viewHistoryDetail(row.item)"
                                  style="cursor: pointer; color: #3699ff"
                                >
                                  <span v-text="row.item.id"></span>
                                </div>
                              </template>
                            </b-table>
                          </b-container>
                        </div>

                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                        >
                          <b-container fluid class="px-8">
                            <b-row>
                              <b-col>
                                <FileUploadManager
                                  :entity-id="mainModel.billNumber"
                                  :entity="'bills'"
                                  :disabled="!mainModel.editable"
                                />
                              </b-col>
                            </b-row>
                          </b-container>
                        </div>
                        <!-- Phiếu thu cũ -->
                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                        >
                          <TradeIn
                            :tradeIn="tradeIn"
                            :customerId="mainModel.customerModel.customerId"
                            :billId="mainModel.id"
                          />
                        </div>
                        <!-- Phiếu sửa chữa (M7 V2) -->
                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                        >
                          <RepairSlipLink :repair-slip-id="mainModel.repairSlipId" />
                        </div>
                      </div>
                    </div>
                  </div>
                </b-skeleton-wrapper>
              </div>
            </div>
          </div>
          <!--end: Wizard Nav -->
        </b-card>
        <BillGiftModal
          ref="bill-gift-modal"
          :billItemId="selectedBillItem.billItemId"
          :productName="selectedBillItem.productName"
          :storeId="mainModel.storeId"
          v-on:addGift="addGift"
        />
        <BillAttachModal
          ref="bill-attach-modal"
          :billItemId="selectedBillItem.billItemId"
          :productName="selectedBillItem.productName"
          :storeId="mainModel.storeId"
          :attachItems="selectedBillItem.attachItems"
          :productId="selectedBillItem.productId"
          :page="selectedBillItem.page"
          :limit="selectedBillItem.limit"
          :totalPage="selectedBillItem.totalPage"
          :totalRow="selectedBillItem.totalRow"
          :searchProduct="selectedBillItem.searchProduct"
          v-on:addAttach="addAttach"
        />
        <BillWarrantyModal
          ref="bill-warranty-modal"
          :productName="selectedBillItem.productName"
          :storeId="mainModel.storeId"
          :productId="selectedBillItem.productId"
          v-on:addWarranty="addWarranty"
        />
        <ChangeGiftModal
          ref="change-gift-modal"
          :productId="selectedBillItem.productId"
          :listProductVariant="selectedBillItem.listProductVariant"
          v-on:changeGift="onChangeGift"
        />
        <BillNoteModal
          ref="bill-note-modal"
          :productName="selectedBillItem.productName"
          :note="selectedBillItem.note"
          v-on:addNote="onChangeNote"
        />
        <ImeiListByProduct
          ref="list-imei-modal"
          :billItemId="selectedBillItem.billItemId"
          :productName="selectedBillItem.productName"
          :storeId="mainModel.storeId"
          :productId="selectedBillItem.productId"
          :excludeImeiCodes="listImeiModalExcludeCodes"
          v-on:applyImei="applyImei"
        />
        <ProductBatchStockListByProduct
          v-if="isFeatureActive('product-batch-stock')"
          ref="list-product-batch-modal"
          :billItemId="selectedBillItem.billItemId"
          :productName="selectedBillItem.productName"
          :storeId="mainModel.storeId"
          :productId="selectedBillItem.productId"
          v-on:productBatchStockCode="applyProductBatchStockCode"
        />
        <UpsertShiftWorkConfigModal
          v-on:fetchShiftWorkConfig="fetchShiftWorkConfig"
          ref="modal-upsert-shiftWork"
          :shiftWorkConfig="shiftWorkConfigSelected"
        />

        <ActiveImei ref="active-imei-modal" />
        <QRCodeModal
          ref="qr-code-modal"
          :qrCode="qrCode"
          :billNumber="mainModel.billNumber"
          :billData="mainModel"
          :type="REFERENCE_TYPE.BILL"
          :transferAmount="transferAmount"
          :payment="qrCodePaymentInfo"
          :storeId="mainModel.storeId"
          @onGenerateQR="onGenerateQR"
          @afterGenerateQR="afterGenerateQR"
        />
        <QRCodeVNPayModal
          ref="qr-code-vnpay-modal"
          :qrCode="qrCode"
          :billNumber="mainModel.billNumber"
          :billData="mainModel"
          :type="REFERENCE_TYPE.BILL"
          :transferAmount="transferAmount"
          :payment="qrCodePaymentInfo"
          :storeId="mainModel.storeId"
          @onGenerateQR="onGenerateQR"
          @afterGenerateQR="afterGenerateQR"
          @onSuccessPayment="onSuccessPayment"
        />
        <SelectTransferMethodModal
          ref="select-transfer-method-modal"
          @select-payment-method="onSelectTransferMethod"
        />
        <QRCodeKredivoModal
          ref="qr-code-kredivo-modal"
          @generateQRCodeKredivo="generateQRCodeKredivo"
        />
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <FlexibleComboModal
          ref="flexible-combo"
          :flexibleComboItem="flexibleComboItem"
          :storeId="mainModel.storeId"
          v-on:addComboChild="addComboChild"
        />
        <VoucherApplyModal
          ref="apply-voucher-modal"
          :billItemId="selectedBillItem.billItemId"
          :productName="selectedBillItem.productName"
          :storeId="mainModel.storeId"
          :productId="selectedBillItem.productId"
          :productAmount="selectedBillItem.productAmount"
          :customerMobile="mainModel.customerModel.customerMobile"
          v-on:applyVoucherItem="onApplyVoucherItem"
        />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import {
  AMOUNT_TYPE,
  BILL_ITEM_TYPE,
  DISCOUNT_AMOUNT_TYPE,
  INSTALLMENT_CODE,
  OTP_DISCOUNT,
  PAYMENT_ENTITY_TYPE,
  PAYMENT_KREDIVO_STATUS,
  PAYMENT_STATUS,
  PAYMENT_TRANSACTION_STATUS,
  PAYMENT_TYPE,
  PRODUCT_SEARCH_TYPE,
  PRODUCT_TYPE,
  REFERENCE_TYPE,
  HISTORY_ACTION_TYPE,
  ACCOUNTANT_PAYMENT_GATEWAY_ENUM,
} from '@/utils/enum';
// import { YEAR_MONTH_DAY_FORMAT, checkIsBeforeTime, formatSpecificDate, DATE_FORMAT } from '@/utils/date';
import KTCodePreview from '@/view/content/CodeTab.vue';
import SaveButton from '@/view/components/common/SaveButton.vue';
import KTWizard from '@/assets/js/components/wizard';
import KTUtil from '@/assets/js/components/util';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import moment from 'moment';
import Swal from 'sweetalert2';
import {
  convertPrice,
  currencyMask,
  makeToastFaile,
  makeToastFailHtml,
  makeToastSuccess,
  unMaskPrice,
} from '@/utils/common';
import decounce from 'debounce';
import { v4, validate as isValidUUID } from 'uuid';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { TIME_TRIGGER } from '@/utils/constants';
import SearchStore from '@/view/components/stores/SearchStore.vue';
import CustomerInfo from '@/view/components/customers/CustomerInfo.vue';
import EmployeeInfo from '@/view/components/bills/EmployeeInfo.vue';
import WarrantyCustomerInfo from '@/view/components/bills/WarrantyCustomerInfo.vue';
import BillPayment from '@/view/components/bills/BillPayment.vue';
import BillNote from '@/view/components/bills/BillNote.vue';
import BillGiftModal from '@/view/components/bills/BillGiftModal';
import BillAttachModal from '@/view/components/bills/BillAttachModal';
import BillWarrantyModal from '@/view/components/bills/BillWarrantyModal';
import ChangeGiftModal from '@/view/components/bills/ChangeGiftModal';
import BillNoteModal from '@/view/components/bills/BillNoteModal';
import ImeiListByProduct from '@/view/components/bills/ImeiListByProduct';
import UpsertShiftWorkConfigModal from '@/view/components/shiftWorkConfig/UpsertShiftWorkConfigModal';
import BillItem from '@/view/components/BillItem.vue';
import ProductBatchStockListByProduct from '@/view/components/bills/ProductBatchStockListByProduct.vue';
import BillTransactions from '@/view/components/BillTransactions.vue';
import ActiveImei from '@/view/components/imeis/ActiveImei';
import WarrantyTransaction from '@/view/components/WarrantyTransaction.vue';
import localData from '@/utils/saveDataToLocal';
import {
  cloneDeep,
  findLastIndex,
  keyBy,
  map,
  omit,
  pullAt,
  sumBy,
  uniq,
} from 'lodash';
import { mapGetters } from 'vuex';
import {
  PURGE_INSTALLMENT_PROGRAM,
  PURGE_INTEREST_ZERO,
  SET_INSTALLMENT_PROGRAM,
  SET_INTEREST,
} from '@/core/services/store/modules/payment/payment-installment.module';
import { EventBus } from '@/core/services/event-bus';
import QRCodeModal from '@/view/components/bills/QRCodeModal.vue';
import QRCodeVNPayModal from '@/view/components/bills/QRCodeVNPayModal.vue';
import SelectTransferMethodModal from '@/view/components/bills/SelectTransferMethodModal.vue';
import QRCodeKredivoModal from '@/view/components/modals/QRCodeKredivoModal.vue';
import db from '@/firebase/init';
import { deleteDoc, doc, onSnapshot } from 'firebase/firestore';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import FlexibleComboModal from '@/view/components/bills/FlexibleComboModal';
import TradeIn from '@/view/components/bills/TradeIn.vue';
import RepairSlipLink from '@/view/components/bills/RepairSlipLink.vue';
import VoucherApplyModal from '@/view/components/voucher/VoucherApplyModal.vue';
import { ProductSearchOption } from './models/ProductSearchOption';
import { BillItemLogicModal } from '@/view/pages/bills/models/BillItemLogicModal';
import {
  buildBillComboItemsPayload,
  collectImeiCodesInBill,
  hasImeiComboChild,
  isImeiCodeInBill,
  normalizeComboItems,
  validateComboImei,
} from '@/view/pages/bills/utils/combo-imei';
import { FlexibleComboSearchOption } from '@/view/pages/bills/models/FlexibleComboSearchOption';
import { SEND_BILL_METHOD_OPTIONS } from '@/view/pages/bills/utils/constants';
import {
  CUSTOMER_NAME_APPELLATION_WARNING_MESSAGE,
  hasCustomerNameAppellationPrefix,
  isValidEmail,
} from '@/utils/validation';
import { showAlert } from '@/utils/sweet-alert2';
import { featureFlagMixin, swalMixin } from '@/view/mixins';
import {
  YEAR_MONTH_DAY_FORMAT,
  checkIsBeforeTime,
  formatSpecificDate,
  DATE_FORMAT,
} from '@/utils/date';
import FileUploadManager from '@/view/modules/upload/FileUploadManager.vue';

const BillVatInfo = () =>
  import(/* webpackPrefetch: true */ '@/view/components/bills/BillVatInfo.vue');
export default {
  mixins: [validationMixin, featureFlagMixin, swalMixin],
  data() {
    return {
      OTP_DISCOUNT,
      PRODUCT_TYPE,
      customerDiscount: null,
      productAttach: {},
      selectingProductId: null,
      isAllowQRCode: false,
      shiftWorkConfigSelected: null,
      shiftWorkConfig: null,
      qrCodePaymentInfo: {},
      REFERENCE_TYPE,
      isLoading: false,
      fullPage: true,
      qrCode: {
        image: '',
        code: '',
      },
      productLoading: false,
      listTypeSearch: [
        {
          id: PRODUCT_SEARCH_TYPE.PRODUCT_NAME,
          name: 'Tìm sản phẩm',
        },
        {
          id: PRODUCT_SEARCH_TYPE.IMEI_CODE,
          name: 'Tìm sản phẩm IMEI',
        },
        {
          id: PRODUCT_SEARCH_TYPE.FLEXIBLE_COMBO,
          name: 'Tìm bộ combo',
        },
        {
          id: PRODUCT_SEARCH_TYPE.PRODUCT_BATCH,
          name: 'Tìm mã lô',
        },
      ],
      selectTypeSearch: 1,
      filteredOptionsProduct: [{ data: [] }],
      optionsProduct: [
        {
          data: [],
        },
      ],
      searchProduct: '',
      isSearching: false,
      filteredOptionsStore: [],
      optionsStore: [
        {
          data: [],
        },
      ],
      searchStore: '',
      inputSearchProductProp: {
        class: 'autosuggest__input',
        placeholder: 'Tìm kiếm theo tên, mã, mã vạch sản phẩm',
        disabled: true,
      },
      mainModel: {
        id: null,
        billNumber: null,
        // M7 V2: Bill auto-tạo từ phiếu sửa chữa (DV Bảo hành) — null cho bill thường
        repairSlipId: null,
        storeId: null,
        stockSlipId: null,
        storeName: '',
        storeShortName: '',
        siteCode: '',
        discountType: 1,
        discountAmount: 0,
        couponCode: '',
        // tắt tự động cộng điểm tiêu dùng
        isCountPoint: false,
        // isCountPoint: true,
        subtractPoint: 0,
        otpCode: '',
        otpCodeDmem: '',
        isSubtractPointValidated: false,
        moneyTransfered: 0,
        moneyPaid: 0,
        moneyCredit: 0,
        moneyInstallment: 0,
        totalAmountPoint: 0,
        customerShipFee: 0,
        codeShip: '',
        customerModel: {
          customerId: null,
          customerMobile: '',
          customerName: '',
          customerLastName: '',
          customerAddress: '',
          customerCity: null,
          customerDistrict: null,
          customerWard: null,
          totalPoint: 0,
          customerAppellation: null,
          customerLevel: null,
          customerEmail: '',
          customerDOB: null,
        },
        warrantyCustomerModel: {
          customerId: null,
          customerMobile: '',
          customerName: '',
          customerLastName: '',
        },
        billEmployeeInfo: {
          saleId: null,
          saleName: '',
          technicalId: null,
          technicalName: '',
          cashierId: null,
          cashierName: '',
          accessoryStaffId: null,
          accessoryStaffName: '',
          managerId: null,
          managerName: '',
          assistantId: null,
          assistantName: '',
          customerReceptionId: null,
          customerReceptionName: '',
          shipperId: null,
          shipperName: '',
        },
        companyBill: false,
        vatInvoice: {
          vatCompanyType: 1,
          taxCode: '',
          companyAddress: '',
          companyName: '',
          email: '',
        },
        paymentInfo: {
          //tiền mặt
          cashAmount: 0,
          cashAccountantName: '',
          cashAccountId: null,
          //chuyển khoản
          transferAmount: 0,
          transferAccountantName: '',
          transferAccountantId: null,
          transferReferenceCode: '',
          //quẹt thẻ
          creditAmount: 0,
          creditAccountantName: '',
          creditAccountantId: null,
          creditCode: '',
          creditCardNo: '',
          //phí quẹt thẻ
          creditCardFee: 0,
          creditFeeAccountantName: '',
          creditFeeAccountantId: null,
          payCreditFeeType: 1,
          //trả góp
          installedMoneyAmount: 0,
          installmentCode: '',
          installmentAccountName: '',
          installMoneyAccountId: null,
          customerIndentifyNo: '',
          installmentProgramMonthNo: 0,
          installmentProgramPrepayPercent: 0,
          installmentProgramPrepayAmount: 0,
        },
        billNote: {
          customerNote: '',
          saleNote: '',
          warrantyNote: '',
        },
        orderSourceId: null,
        editable: true,
        fromBillNumber: null,
        storeDisable: false,
        installments: [],
        credits: [],
        transfer: [],
        cash: [],
        refunds: [],
      },
      mockupCustomerForBill: {},
      listBillItem: [],
      listAmountType: [
        {
          id: 1,
          name: '$',
        },
        {
          id: 2,
          name: '%',
        },
      ],
      mask: currencyMask,
      stateCouponCode: null,
      stateOTP: null,
      stateOTPDmem: null,
      isValidCoupon: false,
      validCouponCode: '',
      selectedBillItem: {
        billItemId: null,
        productName: '',
        productId: null,
        // vị trí ô IMEI con combo đang chọn từ modal Danh sách IMEI
        comboChildIndex: null,
        comboImeiSlotIndex: null,
        attachItems: [],
        listProductVariant: [],
        note: '',
        page: 1,
        limit: 10,
        searchProduct: '',
        totalPage: 1,
        totalRow: 1,
      },
      isValidImei: true,
      onSubmiting: false,
      pointSetting: {
        rate: 0,
        allowRoundToDown: false,
      },
      listCustomerSource: [],
      couponValue: 0,
      hashName: null,
      histories: [],
      historyFields: [
        {
          key: 'updatedBy',
          label: 'Người tạo',
          thStyle: { textAlign: 'center' },
        },
        {
          key: 'action',
          label: 'Hành động',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
        },
        {
          key: 'detail',
          label: 'Chi tiết',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
        },
      ],
      prevSubtractPoint: 0,
      isUseDiscountDmem: false,
      prevCouponCode: '',
      renderComponent: false,
      pageTitle: null,
      onPaymentSubmiting: false,
      orderNotComplete: null,
      isValidTaxCode: true,
      isValidEmail: true,
      transferAmount: 0,
      flexibleComboItem: {
        id: null,
        name: '',
        code: '',
        discountAmount: 0,
        discountType: AMOUNT_TYPE.MONEY,
        listItem: [],
      },
      tradeIn: {},
      billType: null,
      isEnableSendBillMethod: false,
      selectedSendBillMethod: null,
      sendBillMethodOptions: SEND_BILL_METHOD_OPTIONS,
      remainAmount: null,
      reRenderComponentBillPayment: 0,
      isEnableInstallmentKredivo: false,
      refundMoneyFromOrder: 0,
    };
  },
  validations: {
    searchStore: {
      required,
    },
  },
  components: {
    Loading,
    KTCodePreview,
    SaveButton,
    SearchStore,
    BillItem,
    CustomerInfo,
    EmployeeInfo,
    WarrantyCustomerInfo,
    BillVatInfo,
    BillPayment,
    BillNote,
    BillGiftModal,
    BillAttachModal,
    BillWarrantyModal,
    ChangeGiftModal,
    BillNoteModal,
    ImeiListByProduct,
    BillTransactions,
    WarrantyTransaction,
    ActiveImei,
    QRCodeModal,
    QRCodeVNPayModal,
    SelectTransferMethodModal,
    QRCodeKredivoModal,
    UpsertShiftWorkConfigModal,
    FlexibleComboModal,
    TradeIn,
    RepairSlipLink,
    VoucherApplyModal,
    ProductBatchStockListByProduct,
    FileUploadManager,
  },
  destroyed() {
    this.$store.dispatch(PURGE_INTEREST_ZERO);
    this.$store.dispatch(PURGE_INSTALLMENT_PROGRAM);
    EventBus.$off('onSelectTradeIn', this.onSelectTradeIn);
  },
  watch: {
    getInstallmentInterestZero: {
      handler(value) {
        this.fetchProgramByProductIds(value);
      },
      deep: true,
    },
    listBillItem: {
      async handler(oldValue, newValue) {
        if (newValue.length > 0) {
          await this.changeDiscountComponentCustomerInfo();
        }
      },
      deep: true,
    },
    'mainModel.customerModel.customerId': {
      async handler(oddValue, newValue) {
        if (oddValue !== newValue) {
          this.isUseDiscountDmem = this.isValidDiscountDmem;
          this.mainModel.otpCodeDmem = '';
          this.stateOTPDmem = null;
          await this.changeDiscountComponentCustomerInfo();
        }
      },
      deep: true,
    },
    remainAmount: {
      handler() {
        //   for (const element of this.listBillItem) {
        //     if ('isSoftwareProduct' in element) {
        //       if (element.isSoftwareProduct && this.remainAmount <= 0) {
        //         this.isEnableSendBillMethod = true;
        //         return;
        //       }
        //     }
        //     this.isEnableSendBillMethod = false;
        //     this.selectedSendBillMethod = null;
        //   }
        // },
        let hasSoftwareProduct = false;
        let hasVieonProduct = false;
        for (const element of this.listBillItem) {
          if ('isSoftwareProduct' in element && element.isSoftwareProduct) {
            hasSoftwareProduct = true;
          }
          if ('isVieonProduct' in element && element.isVieonProduct) {
            hasVieonProduct = true;
          }
          // Nếu điều kiện remainAmount <= 0 và có isSoftwareProduct hoặc isVieonProduct
          if (
            (hasSoftwareProduct || hasVieonProduct) &&
            this.remainAmount <= 0
          ) {
            this.isEnableSendBillMethod = true;
            return;
          }
        }
        // Nếu không thỏa mãn bất kỳ điều kiện nào, tắt phương thức gửi hóa đơn
        this.isEnableSendBillMethod = false;
        this.selectedSendBillMethod = null;
      },
      deep: true,
      immediate: true,
    },
    'mainModel.otpCodeDmem': {
      async handler(value) {
        if (!value) {
          this.isUseDiscountDmem = false;
          await this.changeDiscountComponentCustomerInfo();
        }
      },
      deep: true,
    },
    'mainModel.otpCode': {
      handler(value) {
        if (!value) {
          this.prevSubtractPoint = 0;
          this.mainModel.subtractPoint = 0;
          this.mainModel.isSubtractPointValidated = false;
        }
      },
      deep: true,
    },
    'mainModel.subtractPoint': {
      async handler(value) {
        if (!unMaskPrice(value)) {
          this.prevSubtractPoint = 0;
          this.mainModel.subtractPoint = 0;
          this.mainModel.isSubtractPointValidated = false;
          this.mainModel.otpCode = null;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['getInstallmentInterestZero', 'getInstallmentProgram']),
    /**
     * IMEI đã dùng ở chỗ khác trong HĐ => ẩn khỏi modal chọn IMEI, trừ máy đang
     * nằm ở chính ô được sửa (để vẫn thấy lựa chọn hiện tại). Nhờ vậy vị trí FIFO
     * (row.index === 0) tính trên đúng các máy còn chọn được.
     */
    listImeiModalExcludeCodes() {
      const { billItemId, comboChildIndex, comboImeiSlotIndex } =
        this.selectedBillItem;
      const billItem = (this.listBillItem || []).find(
        (item) => item.id === billItemId,
      );
      let currentCode = '';
      if (billItem) {
        const isComboSlot =
          comboChildIndex !== null &&
          comboChildIndex !== undefined &&
          comboImeiSlotIndex !== null &&
          comboImeiSlotIndex !== undefined;
        if (isComboSlot) {
          const child = (billItem.comboItems || [])[comboChildIndex];
          const codes =
            child && Array.isArray(child.imeiCodes) ? child.imeiCodes : [];
          currentCode = codes[comboImeiSlotIndex] || '';
        } else {
          currentCode = billItem.imeiCode || '';
        }
      }
      currentCode = String(currentCode).trim();
      return collectImeiCodesInBill(this.listBillItem).filter(
        (code) => code !== currentCode,
      );
    },
    isValidUsePoint() {
      return this.featureFlags.some((item) => item === 'bill-use-point');
    },
    isValidUseDMem() {
      return this.featureFlags.some((item) => item === 'bill-use-dmem');
    },
    isEnabledValidateEmailCustomer() {
      return this.featureFlags.some(
        (featureFlagName) => featureFlagName === 'bill-validate-email-customer',
      );
    },
    isEnableValidateCustomerInfo(){
      return this.featureFlags.some((item) => item === 'validate-customer-info');
    },
    isEnableValidateCustomerDOB(){
      return this.featureFlags.some((item) => item === 'validate-customer-birthday');
    },
    isValidDiscountDmem() {
      const billCreateDate = moment(
        this.mainModel.billCreatedAt,
        'HH:mm DD/MM/YYYY',
        true,
      );
      const currentDate = moment();
      // nếu ngày tạo bill nhỏ hơn ngày hiện tại thì trả về false
      // tránh trường hợp VD đang hạng Bạc mua qua ngày sau vào cập nhật bill tự chiết khấu của hạng Vàng
      if (billCreateDate.isBefore(currentDate, 'day')) {
        return false;
      }
      const _isUseDiscountDmem = this.listBillItem.filter(
        (item) => item.customerDiscountAmount,
      );
      return _isUseDiscountDmem.length ? true : false;
    },
    totalAmountBeforeDiscount() {
      let total = 0;
      for (let index = 0; index < this.listBillItem.length; index++) {
        const element = this.listBillItem[index];
        if (element.billItemType === BILL_ITEM_TYPE.PRODUCT) {
          const totalPrice =
            unMaskPrice(element.price) * unMaskPrice(element.quantity);
          // Check discount type
          total += totalPrice;
        } else if (
          element.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS &&
          element.checked === false
        ) {
          total -=
            unMaskPrice(element.returnPrice) * unMaskPrice(element.quantity);
        } else if (
          element.billItemType === BILL_ITEM_TYPE.PRODUCT_PROMTION &&
          element.checked === true
        ) {
          total +=
            unMaskPrice(element.returnPrice) * unMaskPrice(element.quantity);
        }
      }
      return total;
    },
    interestZeroExchange() {
      const [firstInstallment] = this.mainModel.installments;
      if (firstInstallment) {
        return firstInstallment.child
          ? firstInstallment.child.paymentAmount
          : 0;
      }
      return 0;
    },
    interestZeroLoan() {
      if (!this.interestZeroPrePaid) return 0;
      return this.finalAmount - this.interestZeroPrePaid;
    },
    interestZeroPrePaid() {
      return (
        (this.finalAmount *
          this.getInstallmentProgram.installmentProgramPrepayPercent || 0) / 100
      );
    },
    totalAmount() {
      let total = 0;
      for (let index = 0; index < this.listBillItem.length; index++) {
        const element = this.listBillItem[index];
        if (element.quantity != 0) {
          if (element.billItemType === BILL_ITEM_TYPE.PRODUCT) {
            // total giá chiết khấu
            let totalPrice =
              unMaskPrice(element.price) * unMaskPrice(element.quantity);
            // Check discount type
            if (element.discountType == AMOUNT_TYPE.PERCENT) {
              let discountAmount = totalPrice * element.discount;
              totalPrice = totalPrice - (discountAmount / 100).toFixed(0);
            } else {
              totalPrice = totalPrice - unMaskPrice(element.discount);
            }
            if (element.customerDiscountType === 'percent') {
              let amount = totalPrice * (element.customerDiscountAmount / 100);
              if (
                element.customerDiscountMaxAmount &&
                amount > element.customerDiscountMaxAmount
              ) {
                amount = element.customerDiscountMaxAmount;
              }
              if (
                element.customerDiscountMaxAmount &&
                amount > element.customerDiscountMaxAmount
              ) {
                amount = element.customerDiscountMaxAmount;
              }
              totalPrice = totalPrice - amount.toFixed(0);
              totalPrice = Number(totalPrice) < 0 ? 0 : totalPrice;
              element.customerDiscountSellingPrice = totalPrice;
            }
            if (element.customerDiscountType === 'amount') {
              totalPrice =
                totalPrice - element.customerDiscountAmount < 0
                  ? 0
                  : totalPrice - element.customerDiscountAmount;
              element.customerDiscountSellingPrice = totalPrice;
            }
            total += totalPrice;
          } else if (
            element.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS &&
            element.checked === false
          ) {
            total -=
              unMaskPrice(element.returnPrice) * unMaskPrice(element.quantity);
          } else if (
            element.billItemType === BILL_ITEM_TYPE.PRODUCT_PROMTION &&
            element.checked === true
          ) {
            let totalPrice =
              unMaskPrice(element.returnPrice) * unMaskPrice(element.quantity);
            if (element.customerDiscountType === 'percent') {
              let amount = totalPrice * (element.customerDiscountAmount / 100);
              if (
                element.customerDiscountMaxAmount &&
                amount > element.customerDiscountMaxAmount
              ) {
                amount = element.customerDiscountMaxAmount;
              }
              totalPrice = totalPrice - amount.toFixed(0);
              totalPrice = Number(totalPrice) < 0 ? 0 : totalPrice;
              element.customerDiscountSellingPrice = totalPrice;
            }
            if (element.customerDiscountType === 'amount') {
              totalPrice =
                totalPrice - element.customerDiscountAmount < 0
                  ? 0
                  : totalPrice - element.customerDiscountAmount;
              element.customerDiscountSellingPrice = totalPrice;
            }
            total += totalPrice;
          }
        }
      }
      const discountAmount = this.mainModel.discountAmount
        ? unMaskPrice(this.mainModel.discountAmount)
        : 0;
      if (this.mainModel.discountType == AMOUNT_TYPE.MONEY) {
        total = total - discountAmount;
      } else {
        total = total - (total * discountAmount) / 100;
      }
      return total > 0 ? total : 0;
    },
    totalAmountReturn() {
      let total = 0;
      for (let index = 0; index < this.listBillItem.length; index++) {
        const element = this.listBillItem[index];
        if (
          element.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS &&
          element.checked === false
        ) {
          total +=
            unMaskPrice(element.returnPrice) * unMaskPrice(element.quantity);
        }
      }
      return total > 0 ? total : 0;
    },
    addPoint() {
      if (!this.pointSetting.rate) {
        return 0;
      }
      if (this.pointSetting.allowRoundToDown) {
        return this.totalAmount
          ? parseInt(this.totalAmount / this.pointSetting.rate)
          : 0;
      }
      return this.totalAmount
        ? Math.ceil(this.totalAmount / this.pointSetting.rate)
        : 0;
    },
    finalAmount() {
      if (!this.totalAmount) {
        return 0;
      }
      const final =
        this.totalAmount -
        this.mainModel.moneyTransfered -
        this.mainModel.moneyPaid -
        this.mainModel.moneyCredit -
        this.mainModel.moneyInstallment -
        this.mainModel.totalAmountPoint +
        this.mainModel.customerShipFee +
        Number(this.refundMoneyFromOrder);
      return final || 0;
    },
    totalPaid() {
      return (
        this.mainModel.moneyPaid +
        this.mainModel.moneyTransfered +
        this.mainModel.moneyCredit +
        this.mainModel.moneyInstallment
      );
    },
    selectedProductIds() {
      if (
        !this.listBillItem ||
        this.listBillItem.length < 1 ||
        !this.selectingProductId
      ) {
        return [];
      }
      const productIds = map(this.listBillItem, 'productId');
      const index = findLastIndex(productIds, (item) => {
        return item === this.selectingProductId;
      });
      pullAt(productIds, productIds[index]);
      return uniq(productIds);
    },
    isEnabledAttachImeiCombo() {
      return this.isFeatureActive('attach-warranty-imei-combo');
    },
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Hóa đơn bán lẻ', route: '/bills' },
      { title: 'Danh sách hóa đơn bán lẻ', route: '/bills' },
      { title: 'Thêm mới hóa đơn bán lẻ' },
    ]);
    this.getPointRate();
    this.getListOrderSource();
    this.mainModel.orderId = this.$route.query.fromOrderId
      ? this.$route.query.fromOrderId
      : null;
    // M7 V3: prefill Bill từ phiếu sửa chữa khi KTBH chuyển sang "Đã trả máy"
    const fromRepairSlipId = this.$route.query.fromRepairSlipId || null;
    this.mainModel.billNumber = this.$route.query.id
      ? this.$route.query.id
      : null;
    if (this.mainModel.billNumber) {
      if (this.$route.name === 'add-bill') {
        this.mainModel.fromBillNumber = this.$route.query.id;
      } else {
        this.isAllowQRCode = true;
      }
      this.getBillById();
      this.fetchBillHistory();
    } else if (this.mainModel.orderId) {
      this.getOrderById();
    } else if (fromRepairSlipId) {
      this.mainModel.repairSlipId = fromRepairSlipId;
      this.getRepairSlipById(fromRepairSlipId);
    } else {
      this.renderComponent = true;
    }
    if (this.$route.query.type === 'convert') {
      this.billType = 'convert';
    }
    // Initialize form wizard
    const hashName = this.$route.hash ? this.$route.hash.split('#')[1] : '';
    this.hashName = hashName === 'attach' ? 'attach' : null;
    const wizard = new KTWizard('kt_wizard_v4_bill', {
      startStep: hashName === 'attach' ? 3 : 1, // initial active step number
      clickableSteps: true, // allow step clicking
    });
    wizard.on('beforeNext', function (/*wizardObj*/) {});
    wizard.on('change', function (/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, TIME_TRIGGER);
    });
    this.fetchStoreByUser();
    await this.getPaymentResult();
    await this.listenEventPaymentInstallment();
    EventBus.$on('onSelectTradeIn', this.onSelectTradeIn);
    EventBus.$emit('billNumber', this.$route.query.id);
    // this.checkIfContainsSoftwareProducts();
    this.checkIfContainsPartnerProducts();
  },
  methods: {
    async updateWarrantyImeiNo({ warrantyImeiNo, productItem }) {
      await this.fetchProductAttach(
        productItem.productId,
        productItem.id,
        warrantyImeiNo,
      );
    },
    showAlert,
    getHistoryActionLabel(action) {
      switch (action) {
        case HISTORY_ACTION_TYPE.UPDATE:
          return 'Sửa hóa đơn';
        case HISTORY_ACTION_TYPE.DELETE:
          return 'Xóa hóa đơn';
        case HISTORY_ACTION_TYPE.CREATE:
          return 'Tạo mới hóa đơn';
        case HISTORY_ACTION_TYPE.PRINT:
          return 'In hóa đơn';
        case HISTORY_ACTION_TYPE.PRINT_WARRANTY:
          return 'In bảo hành';
        default:
          return 'Chưa xác định';
      }
    },
    async changeDiscountComponentCustomerInfo() {
      this.customerDiscount = null;
      await this.fetchDiscountCustomerType();
      if (this.customerDiscount) {
        this.handlerDiscountCustomerType(this.listBillItem);
      }
    },
    async handlerDiscountCustomerType(listBillItem) {
      if (this.customerDiscount) {
        for (let i = 0; i < listBillItem.length; i++) {
          const item = listBillItem[i];
          if (!item['customerTypeId']) {
            // nếu customerTypeId không tồn tại thì check xem có chiết khấu cho product đó k
            if (
              this.customerDiscount[item.productId] &&
              this.customerDiscount[item.productId]['sellingDiscount']
            ) {
              item['customerDiscountType'] =
                this.customerDiscount[item.productId]['typeDiscount'];
              item['sellingDiscount'] =
                this.customerDiscount[item.productId]['sellingDiscount'];
              item['customerDiscountAmount'] =
                this.customerDiscount[item.productId]['value'];
              item['customerDiscountMaxAmount'] =
                this.customerDiscount[item.productId]['maxValue'];
              item['customerTypeId'] =
                this.customerDiscount[item.productId]['customerTypeId'];
            } else {
              item['customerTypeId'] = null;
              item['customerDiscountType'] = null;
              item['sellingDiscount'] = null;
              item['customerDiscountAmount'] = null;
              item['customerDiscountMaxAmount'] = null;
            }
          } else {
            // nếu tồn tại thì giữ nguyên data trả về
            item['customerTypeId'] = item['customerTypeId'] || null;
            item['customerDiscountType'] = item['customerDiscountType'] || null;
            item['sellingDiscount'] = item['sellingDiscount'] || null;
            item['customerDiscountAmount'] =
              item['customerDiscountAmount'] || null;
            item['customerDiscountMaxAmount'] =
              item['customerDiscountMaxAmount'] || null;
          }
        }
      }
      this.listBillItem = listBillItem;
    },
    async fetchDiscountCustomerType() {
      const billData = this.setBillData();
      const listItem = this.listBillItem;
      if (!this.isUseDiscountDmem) {
        this.customerDiscount = null;
        for (let i = 0; i < listItem.length; i++) {
          const item = listItem[i];
          item['customerTypeId'] = item['customerTypeId'] || null;
          item['customerDiscountType'] = item['customerDiscountType'] || null;
          item['sellingDiscount'] = item['sellingDiscount'] || null;
          item['customerDiscountAmount'] =
            item['customerDiscountAmount'] || null;
          item['customerDiscountMaxAmount'] =
            item['customerDiscountMaxAmount'] || null;
        }
        this.listBillItem = listItem;
        return this.customerDiscount;
      }
      if (billData.customerId && billData.listBillItem.length) {
        const body = {
          productIds: map(listItem, 'productId'),
          customerPhone: billData.customerMobile,
        };
        if (billData.billNumber) {
          body['billNumber'] = billData.billNumber;
        }
        const { data } = await ApiService.post(`customer/discount`, body);
        this.customerDiscount = keyBy(data.data, 'id');
      }
    },
    onSelectTradeIn(tradeIn) {
      this.tradeIn = { ...tradeIn };
      this.mainModel.stockSlipId = tradeIn.stockSlip.id;
    },
    onClickGenerateQR(payment) {
      if (payment.status === PAYMENT_STATUS.SUCCESS) {
        return makeToastFaile('Vui lòng tạo thanh toán mới!');
      }
      this.qrCodePaymentInfo = payment;

      /* Nếu là thanh toán qua MOMO ONLINE thì hiển thị modal QR MOMO không cần select phương thức thanh toán */
      if (payment.paymentRefCode.toUpperCase() === ACCOUNTANT_PAYMENT_GATEWAY_ENUM.MOMO_ONLINE) {
        return setTimeout(() => {
          this.$refs['qr-code-modal'].generateQRCode();
        }, TIME_TRIGGER);
      }

      return setTimeout(() => {
        this.$refs['select-transfer-method-modal'].showModal(payment);
      }, TIME_TRIGGER);
    },
    onSelectTransferMethod(type = ACCOUNTANT_PAYMENT_GATEWAY_ENUM.SEPAY) {
      if (type === ACCOUNTANT_PAYMENT_GATEWAY_ENUM.VNPAY) {
        return setTimeout(() => {
          this.$refs['qr-code-vnpay-modal'].generateQRCode();
        }, TIME_TRIGGER);
      }
      return setTimeout(() => {
        this.$refs['qr-code-modal'].generateQRCode();
      }, TIME_TRIGGER);
    },
    onClickCheckoutKredivo(payment) {
      this.isLoading = true;
      setTimeout(() => {
        this.generateQRCodeKredivo(payment);
        this.isLoading = false;
      }, TIME_TRIGGER);
    },
    async onClickCheckStatusKredivo(payment) {
      this.isLoading = true;
      const payload = { transaction_id: payment.pendingTransactionId };
      const statusMessages = {
        [PAYMENT_KREDIVO_STATUS.PENDING]: 'Khách hàng chưa hoàn tất giao dịch!',
        [PAYMENT_KREDIVO_STATUS.DENIED]: 'Đơn trả góp đã bị Kredivo từ chối!',
        [PAYMENT_KREDIVO_STATUS.EXPIRED]: 'Hết thời hạn giao dịch!',
        [PAYMENT_KREDIVO_STATUS.SETTLED]: 'Thanh toán thành công!',
        [PAYMENT_KREDIVO_STATUS.CANCEL]:
          'Giao dịch đã bị huỷ trên Dashboard Kredivo!',
        [PAYMENT_KREDIVO_STATUS.FAILED]:
          'Đơn hàng đã bị huỷ do quá thời gian xác nhận!',
        [PAYMENT_KREDIVO_STATUS.ABORTED]:
          'Giao dịch đơn này đã bị huỷ bỏ.<br/> Tạo lại đơn mới để có thể trả góp qua Kredivo!',
      };
      try {
        const response = await ApiService.post(
          `/installments/kredivo/transaction/check-status/${payment.id}`,
          payload,
        );
        const { status } = response.data.data;
        let icon = 'error';
        let title = 'Thất bại';
        let description = statusMessages[status];
        if (status === PAYMENT_KREDIVO_STATUS.SETTLED) {
          const responseData = response.data?.data?.data || {};
          const amountPaid =
            convertPrice(responseData.amount) || 'Lỗi khi lấy dữ liệu';
          const totalDownpayment = responseData.total_downpayment || 0;
          icon = 'success';
          title = 'Giao dịch thành công';
          description = `
            <p>Số tiền đã thanh toán: ${amountPaid}</p>
            <p>Số tiền chưa thanh toán: ${convertPrice(totalDownpayment)}</p>
          `;
          await this.getBillByIdAndReRenderBillPayment();
        } else if (status === PAYMENT_KREDIVO_STATUS.PENDING) {
          icon = 'warning';
          title = 'Chờ khách hàng xác nhận';
        } else {
          await this.getBillByIdAndReRenderBillPayment();
        }
        this.showAlert(title, description, icon);
      } catch (err) {
        const description = err.response
          ? err.response.data.message
          : 'Lỗi mạng!';
        this.showAlert('Không thành công', description, 'error');
      } finally {
        this.isLoading = false;
      }
    },
    async onClickCancelTransactionKredivo(payment) {
      this.isLoading = true;
      const payload = {
        orderId: this.mainModel.id,
        storeId: this.mainModel.storeId,
      };
      try {
        const response = await ApiService.post(
          `/installments/kredivo/checkout/${payment.id}/abort/${payment.pendingTransactionId}`,
          payload,
        );
        await this.getBillById();
        this.reRenderComponentBillPayment++;
        this.showAlert('Thành công', response.data.message, 'success');
      } catch (err) {
        const description = err.response
          ? err.response.data.message
          : 'Lỗi mạng!';
        this.showAlert('Không thể huỷ giao dịch', description, 'error');
      } finally {
        this.isLoading = false;
      }
    },
    onGenerateQR() {
      this.isLoading = true;
    },
    afterGenerateQR() {
      this.isLoading = false;
    },
    onSuccessPayment() {
      Swal.fire('Thành công', 'Bạn đã thanh toán thành công!', 'success').then(
        () => {
          this.$router.go(this.$router.currentRoute);
        },
      );
    },
    async getPaymentResult() {
      const VERIFY_COLLECTION = 'payment-verify-results';
      onSnapshot(
        doc(db, VERIFY_COLLECTION, String(this.mainModel.billNumber)),
        (snap) => {
          if (snap.exists()) {
            const snapData = snap.data();
            if (
              String(snapData.referenceNumber) ===
              String(this.mainModel.billNumber)
            ) {
              //  remove doc
              deleteDoc(
                doc(db, VERIFY_COLLECTION, String(this.mainModel.billNumber)),
              );
              this.$refs['qr-code-modal'].hideModal();
              Swal.fire(
                'Thành công',
                'Bạn đã thanh toán thành công!',
                'success',
              ).then(() => {
                this.$router.go(this.$router.currentRoute);
              });
            }
          }
        },
      );
    },
    async listenEventPaymentInstallment() {
      const VERIFY_COLLECTION = 'installment-results';
      onSnapshot(
        doc(db, VERIFY_COLLECTION, String(this.mainModel.billNumber)),
        (snap) => {
          if (!snap.exists()) return;
          const snapData = snap.data();
          if (
            String(snapData.referenceNumber) !==
            String(this.mainModel.billNumber)
          ) {
            return;
          }
          deleteDoc(
            doc(db, VERIFY_COLLECTION, String(this.mainModel.billNumber)),
          );
          if (snapData.paymentCode === INSTALLMENT_CODE.KREDIVO_OFFLINE) {
            if (snapData.paymentStatus === PAYMENT_STATUS.SUCCESS) {
              return this.handlePaymentResult(
                'Thành công',
                'Trả góp qua Kredivo thành công!',
                'success',
              );
            } else {
              return this.handlePaymentResult(
                'Thất bại',
                'Trả góp qua Kredivo thất bại!',
                'error',
              );
            }
          }
        },
      );
    },
    handlePaymentResult(title, text, icon) {
      Swal.fire(title, text, icon).then(() => {
        this.$router.go(this.$router.currentRoute);
      });
    },
    onShiftWorkConfigSelected() {
      for (const jobTitle in this.mainModel.billEmployeeInfo) {
        if (jobTitle != 'saleId' && jobTitle != 'saleName') {
          this.mainModel.billEmployeeInfo[jobTitle] =
            this.shiftWorkConfig[jobTitle];
        }
      }
    },
    resetEmployData() {
      for (const key in this.mainModel.billEmployeeInfo) {
        if (key != 'saleId' && key != 'saleName') {
          if (key.includes('Id')) {
            this.mainModel.billEmployeeInfo[key] = null;
          } else if (key.includes('Name')) {
            this.mainModel.billEmployeeInfo[key] = '';
          }
        }
      }
    },
    linkToOrder: function (item) {
      const { href } = this.$router.resolve({
        name: 'edit-order',
        params: { id: item },
      });
      window.open(href, '_blank');
    },
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    formatMoney(value) {
      return convertPrice(value);
    },
    async onSelectedProduct(option) {
      if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.FLEXIBLE_COMBO) {
        this.flexibleComboItem.name = option.item.productName;
        this.flexibleComboItem.id = option.item.productId;
        this.flexibleComboItem.code = option.item.productCode;
        this.flexibleComboItem.discountAmount = option.item.discountAmount;
        this.flexibleComboItem.discountType = option.item.discountType;
        this.flexibleComboItem.listItem = option.item.listItem;
        this.showModalFlexibleCombo();
        return;
      }
      this.searchProduct = '';
      const selectedProduct = option.item;
      let imeiCode = '';
      let productType = selectedProduct.productType;
      this.selectingProductId = selectedProduct.productId;
      if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.IMEI_CODE) {
        imeiCode = selectedProduct.imeiCode;
        productType = PRODUCT_TYPE.PRODUCT_IMEI;
      }
      if (
        hasImeiComboChild(selectedProduct.listProductInCombo) &&
        !this.isEnabledAttachImeiCombo
      ) {
        return makeToastFaile(
          `Sản phẩm combo ${selectedProduct.productName} có sản phẩm IMEI chưa được hỗ trợ`,
        );
      }
      const programPrice = this.getInstallmentInterestZero
        ? option.item.listedPrice
        : option.item.sellingPrice;
      const billItem = Object.assign(
        {},
        new BillItemLogicModal({
          data: selectedProduct,
          storeId: this.mainModel.storeId,
          programPrice,
          productType,
          imeiCode,
        }),
      );
      billItem.comboItems = normalizeComboItems(
        billItem.comboItems,
        billItem.quantity,
      );
      if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.IMEI_CODE) {
        if (this.isExistImeiCode(this.listBillItem, imeiCode)) {
          return makeToastFaile('Mã IMEI đã tồn tại trong hóa đơn');
        }
        this.listBillItem.push(billItem);
        await this.fetchProductAttach(selectedProduct.productId, billItem.id);
      } else {
        if (
          selectedProduct.productType === PRODUCT_TYPE.PRODUCT_SERVICE ||
          selectedProduct.productType === PRODUCT_TYPE.PRODUCT_WARRANTY ||
          selectedProduct.quantityInStock > 0
        ) {
          this.listBillItem.push(billItem);
          await this.fetchProductAttach(selectedProduct.productId, billItem.id);
        } else {
          makeToastFaile('Số sản phẩm tồn trong kho không đủ!');
        }
      }
      this.listBillItem = this.sortListBillItem(this.listBillItem);
      this.optionsProduct[0].data = [];
      if (this.getInstallmentInterestZero) {
        this.fetchProgramByProductIds(this.getInstallmentInterestZero);
      }
    },
    onInputChangProduct(text) {
      this.optionsProduct[0].data = [];
      this.filteredOptionsProduct = [
        {
          data: this.optionsProduct[0].data,
        },
      ];
      if (!text) {
        text = '';
        this.productLoading = false;
        return;
      }
      this.productLoading = true;
      this.searchProduct = text.trim();
      this.debounceInputProduct();
    },
    debounceInputProduct: decounce(function () {
      if (this.searchProduct) {
        this.searchProductAPI();
      }
    }, TIME_TRIGGER),
    debounceInputDiscountCustomerType: decounce(function () {
      this.fetchDiscountCustomerType();
    }, TIME_TRIGGER),
    searchProductAPI() {
      if (!this.isSearching) {
        const textSearch = this.searchProduct ? this.searchProduct.trim() : '';
        if (!textSearch) {
          return;
        }
        if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.PRODUCT_NAME) {
          this.fetchProduct(textSearch);
        } else if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.IMEI_CODE) {
          this.fetchProductImei(textSearch);
        } else if (
          this.selectTypeSearch === PRODUCT_SEARCH_TYPE.FLEXIBLE_COMBO
        ) {
          this.searchFlexibleCombo(textSearch);
        }
      }
    },
    fetchProduct(textSearch) {
      this.isSearching = true;
      this.optionsProduct[0].data = [];
      const params = {
        storeId: this.mainModel.storeId,
        searchProduct: textSearch,
        isInterestZero: this.getInstallmentInterestZero,
      };
      const url = params.isInterestZero
        ? 'productSearch/search'
        : 'productSearch';
      ApiService.query(url, {
        params,
      }).then(({ data }) => {
        const products = data.data;
        this.optionsProduct[0].data = products.map((product) => {
          return Object.assign({}, new ProductSearchOption(product));
        });
        this.filteredOptionsProduct = [
          {
            data: this.optionsProduct[0].data,
          },
        ];
        this.isSearching = false;
        this.productLoading = false;
        if (textSearch !== this.searchProduct) {
          this.searchProductAPI();
        }
      });
    },
    fetchProductImei(textSearch) {
      this.isSearching = true;
      this.optionsProduct[0].data = [];
      ApiService.get(
        `productSearch/search-by-imei?storeId=${this.mainModel.storeId}&imeiCode=${textSearch}`,
      ).then(({ data }) => {
        const products = data.data;
        this.optionsProduct[0].data = products.map((product) =>
          Object.assign({}, new ProductSearchOption(product)),
        );
        this.filteredOptionsProduct = [
          {
            data: this.optionsProduct[0].data,
          },
        ];
        this.isSearching = false;
        this.productLoading = false;
        if (textSearch !== this.searchProduct) {
          this.searchProductAPI();
        }
      });
    },
    changePlaceholder() {
      if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.PRODUCT_NAME) {
        this.inputSearchProductProp.placeholder =
          'Tìm kiếm theo tên, mã, mã vạch sản phẩm';
      } else if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.IMEI_CODE) {
        this.inputSearchProductProp.placeholder =
          'Tìm kiếm theo mã IMEI sản phẩm';
      }
      this.optionsProduct[0].data = [];
      this.debounceInputProduct();
    },
    async fetchShiftWorkConfig() {
      if (this.mainModel.storeId) {
        const params = {
          storeId: this.mainModel.storeId,
          billCreatedAt: this.mainModel.billCreatedAt
            ? this.mainModel.billCreatedAt
            : null,
        };
        ApiService.query('shift-work-config/getByStore', { params })
          .then(({ data }) => {
            this.shiftWorkConfig = data.data;
            for (const jobTitle in this.mainModel.billEmployeeInfo) {
              if (!this.mainModel.billEmployeeInfo[jobTitle]) {
                if (jobTitle !== 'saleId' && jobTitle !== 'saleName') {
                  this.mainModel.billEmployeeInfo[jobTitle] =
                    this.shiftWorkConfig[jobTitle];
                }
              }
            }
          })
          .catch(({ response }) => {
            makeToastFaile(response.$error);
          });
      }
    },
    onStoreSelected(storeId) {
      this.mainModel.storeId = storeId;
      this.resetEmployData();
      this.fetchShiftWorkConfig();
      this.inputSearchProductProp.disabled = false;
      this.listBillItem = [];
    },
    isExistImeiCode(listProduct, imeiCode) {
      return isImeiCodeInBill(listProduct, imeiCode);
    },
    async checkInsProgramByProductId(productId) {
      const params = {
        productId: productId,
      };
      return ApiService.query(`installment-programs/product`, {
        params,
      }).then(({ data }) => {
        const product = data.data;
        return product;
      });
    },
    showWarning(text) {
      return Swal.fire({
        title: 'Trả góp 0%!',
        text: `${text}`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: 'rgb(221, 51, 51)',
        confirmButtonText: 'Đồng ý',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
    },
    sortListBillItem(listBillItem) {
      // Turn off mapping for related bill item mapping
      // const listResult = [];
      // const mainItems = listBillItem.filter(
      //   (item) => item.billItemType === BILL_ITEM_TYPE.PRODUCT,
      // );
      // const attachItems = listBillItem.filter(
      //   (item) => item.billItemType !== BILL_ITEM_TYPE.PRODUCT,
      // );
      // mainItems.forEach((billItem, index) => {
      //   billItem.stt = index + 1;
      //   listResult.push(billItem);
      //   let belongBillItems = attachItems.filter(
      //     (item) => item.belongBillDetailId === billItem.id,
      //   );
      //   belongBillItems = sortBy(belongBillItems, ['billItemType']);
      //   belongBillItems.forEach((attachItem) => {
      //     listResult.push(attachItem);
      //   });
      // });
      return listBillItem;
    },
    async fetchProductAttach(productId, parentId, warrantyImeiNo = '') {
      ApiService.get(
        `productSearch/get-product-attach?storeId=${this.mainModel.storeId}&productId=${productId}&isGift=1&warrantyImeiNo=${warrantyImeiNo}`,
      ).then(({ data }) => {
        //response data
        const item = {
          productId: data.data.productId,
          productName: data.data.productName,
          productNameVat: data.data.productNameVat,
          listAccessoryBonus: data.data.listAccessoryBonus,
          listAccessoryPromotion: data.data.listAccessoryPromotion,
        };
        //mapping data to main item
        const billItem = this.listBillItem.find((item) => item.id === parentId);
        if (!billItem) {
          return;
        }
        //gift
        this.listBillItem = this.listBillItem.filter(
          (item) => item.belongBillDetailId !== parentId,
        );
        billItem.listAccessoryBonus = item.listAccessoryBonus;
        item.listAccessoryBonus.forEach((element) => {
          const code = `Quà tặng kèm- ${element.accessoryGroupCode}`;
          const giftItem = {
            id: v4(),
            productId: element.productId,
            name: element.productName,
            productNameVat: element.productNameVat,
            code: code,
            price: element.sellingPrice,
            quantity: 1,
            type: element.productType,
            imeiCode: '',
            totalPrice: element.sellingPrice,
            discount: '',
            quantityInStock: element.quantityInStock,
            storeId: this.selectedClassStore,
            billItemType: BILL_ITEM_TYPE.PRODUCT_BONUS,
            checked: true,
            belongBillDetailId: parentId,
            returnPrice: element.price,
            accessoryGroupId: element.accessoryGroupId,
            accessoryGroupCode: element.accessoryGroupCode,
            listProductVariant: element.listProductVariant,
            isGetVat: false,
            belongToWarrantyImei: element.belongToWarrantyImei || false,
            // Carry cờ quản lý theo lô để dòng tặng kèm hiện picker chọn lô (khớp enforce BE).
            isBatchStockProduct: element.isBatchStockProduct || false,
          };
          if (warrantyImeiNo) {
            const billItemIndex = this.listBillItem.findIndex(
              (item) => item.id === parentId,
            );
            if (billItemIndex !== -1) {
              this.listBillItem.splice(billItemIndex + 1, 0, giftItem);
            }
          } else {
            this.listBillItem.push(giftItem);
          }
        });
        //attach
        billItem.listAccessoryPromotion = item.listAccessoryPromotion;
        this.listBillItem = this.sortListBillItem(this.listBillItem);
      });
    },
    deleteBillItem(id) {
      const index = this.listBillItem.findIndex((item) => item.id === id);
      const billItemDeleted = this.listBillItem[index];
      this.listBillItem = this.listBillItem.filter(
        (billItem) => billItem.id !== id && billItem.belongBillDetailId !== id,
      );
      for (let i = 0; i < billItemDeleted['vouchers'].length; i++) {
        const voucher = billItemDeleted['vouchers'][i];
        const voucherItem = {
          billItemId: billItemDeleted.id,
          cumluativeValues:
            typeof voucher.cumluativeValues === 'object'
              ? voucher.cumluativeValues || []
              : JSON.parse(voucher.cumluativeValues || '[]'),
          voucherCode: voucher.voucherCode,
          voucherDetailId: voucher.voucherDetailId,
          voucherId: voucher.voucherId,
        };
        const typeValue = typeof voucherItem.cumluativeValues;
        const cumluativeValues =
          typeValue === 'string'
            ? JSON.parse(voucherItem.cumluativeValues)
            : voucherItem.cumluativeValues;
        if (cumluativeValues.length) {
          this.reCalVoucherBillItem(voucherItem);
        }
      }
    },
    changeCouponCode() {
      if (
        this.isValidCoupon === true &&
        this.mainModel.couponCode !== this.validCouponCode
      ) {
        this.isValidCoupon = false;
        this.stateCouponCode = null;
      }
    },
    checkCoupon() {
      if (this.listBillItem.length <= 0 || this.listBillItem === []) {
        makeToastFaile('Bạn chưa chọn sản phẩm nào');
        return;
      }
      const billItems = this.formatListBillItem();
      const data = {
        storeId: this.mainModel.storeId,
        listProduct: billItems,
        couponCode: this.mainModel.couponCode,
        customerId: this.mainModel.customerModel.customerId,
      };
      this.onSubmiting = true;
      ApiService.post('coupon/check-coupon', data)
        .then(({ data }) => {
          this.onSubmiting = false;
          if (data.status === 1) {
            makeToastSuccess(data.message);
            if (data.data !== null) {
              this.mainModel.discountAmount = data.data;
              this.couponValue = data.data;
              this.mainModel.discountType = AMOUNT_TYPE.MONEY;
              this.isValidCoupon = true;
              this.validCouponCode = this.mainModel.couponCode;
              this.stateCouponCode = true;
            }
          } else {
            this.stateCouponCode = false;
            makeToastFaile(data.message);
          }
        })
        .catch(({ response }) => {
          this.onSubmiting = false;
          makeToastFaile(response.$error);
        });
    },
    showGiftModal(billItemId) {
      this.selectedBillItem.billItemId = billItemId;
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      setTimeout(() => {
        this.$refs['bill-gift-modal'].showModal();
      }, TIME_TRIGGER);
    },
    addGift(gifts) {
      const normalizedGifts = gifts.map((gift) => ({
        ...gift,
        comboItems: normalizeComboItems(gift.comboItems, gift.quantity, {
          keepImeiCodes: false,
        }),
      }));
      this.listBillItem = this.listBillItem.concat(normalizedGifts);
      this.listBillItem = this.sortListBillItem(this.listBillItem);
    },
    async showAttachModal(billItemId) {
      this.selectedBillItem.billItemId = billItemId;
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.productId = billItem ? billItem.productId : '';
      if (this.productAttach[billItem.productId]) {
        this.selectedBillItem.attachItems =
          this.productAttach[billItem.productId];
      } else {
        try {
          const { data } = await ApiService.get(
            `productSearch/get-product-attach?storeId=${billItem.storeId}&productId=${billItem.productId}&isPromotion=1&page=1&limit=10`,
          );
          if (!data.data) {
            return makeToastFaile(data.message);
          }
          this.selectedBillItem.attachItems =
            data.data.listAccessoryPromotion.data || [];
          this.selectedBillItem.totalPage =
            data.data.listAccessoryPromotion.totalPage;
          this.selectedBillItem.totalRow =
            data.data.listAccessoryPromotion.totalRow;
          // this.productAttach[billItem.productId] =
          //   data.data.listAccessoryPromotion;
        } catch (error) {
          return makeToastFaile(error.message);
        }
      }
      setTimeout(() => {
        this.$refs['bill-attach-modal'].showModal();
      }, TIME_TRIGGER);
    },
    // async fetchProductPromotions(){
    //   const { data } = await ApiService.get(
    //         `productSearch/get-product-attach?storeId=${billItem.storeId}&productId=${billItem.productId}&isPromotion=1&page=1&limit=10`,
    //       );
    //       if (!data.data) {
    //         return makeToastFaile(data.message);
    //       }
    //       this.selectedBillItem.attachItems =
    //         data.data.listAccessoryPromotion.data || [];
    //       this.selectedBillItem.totalPage =
    //         data.data.listAccessoryPromotion.totalPage;
    //       this.selectedBillItem.totalRow =
    //         data.data.listAccessoryPromotion.totalRow;
    // },
    addAttach(attachs) {
      const normalizedAttachs = attachs.map((attach) => ({
        ...attach,
        comboItems: normalizeComboItems(attach.comboItems, attach.quantity, {
          keepImeiCodes: false,
        }),
      }));
      const convertedAttachs =
        this.setExternalImeiNoEachAttachsByParentImei(normalizedAttachs);
      this.listBillItem = this.listBillItem.concat(convertedAttachs);
      this.listBillItem = this.sortListBillItem(this.listBillItem);
    },
    setExternalImeiNoEachAttachsByParentImei(attachs) {
      const billItemMapIds = this.listBillItem.map((billItem) => [
        billItem.id,
        billItem,
      ]);
      const billItemMapKeyById = new Map([...billItemMapIds]);
      const convertedAttachs = attachs.map((attachItem) => {
        if (!attachItem.belongToWarrantyImei) return attachItem;
        const parentProduct = billItemMapKeyById.get(
          attachItem.belongBillDetailId,
        );
        return {
          ...attachItem,
          externalImeiNo: parentProduct.imeiCode,
        };
      });
      return convertedAttachs;
    },
    showWarrantyModal(productId) {
      const billItem = this.listBillItem.find(
        (item) => item.productId === productId,
      );
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.productId = productId;
      setTimeout(() => {
        this.$refs['bill-warranty-modal'].showModal();
      }, TIME_TRIGGER);
    },
    addWarranty(warrantyItems) {
      const listItem = warrantyItems.map((item) => {
        return {
          id: v4(),
          stt: 0,
          productId: item.id,
          name: item.productName,
          productNameVat: '',
          code: item.productCode,
          price: item.sellingPrice,
          type: 4,
          quantity: 1,
          imeiCode: '',
          discount: 0,
          quantityInStock: 0,
          storeId: this.mainModel.storeId,
          comboItems: [],
          billItemType: BILL_ITEM_TYPE.PRODUCT,
          checked: true,
          listAccessoryPromotion: [],
          returnPrice: 0,
          accessoryGroupId: '',
          accessoryGroupCode: '',
          note: '',
          discountType: AMOUNT_TYPE.PERCENT,
          discountProgramId: -1,
          isGetVat: false,
          sellingPrice: item.sellingPrice,
          customerTypeId: null,
          customerDiscountType: null,
          customerDiscountAmount: null,
          customerDiscountSellingPrice: null,
          customerDiscountMaxAmount: null,
        };
      });
      this.listBillItem = this.listBillItem.concat(listItem);
      this.listBillItem = this.sortListBillItem(this.listBillItem);
    },
    checkValidImei(value) {
      this.isValidImei = value;
    },
    updateItem(item) {
      this.listBillItem.forEach((element, index) => {
        if (element.id === item.id) {
          this.listBillItem[index].name = item.name;
          this.listBillItem[index].imeiCode = item.imeiCode;
          this.listBillItem[index].productId = item.productId;
          this.listBillItem[index].price = item.price
            ? unMaskPrice(item.price)
            : 0;
          this.listBillItem[index].quantity = item.quantity
            ? unMaskPrice(item.quantity)
            : 0;
          this.listBillItem[index].discount = item.discount
            ? unMaskPrice(item.discount)
            : 0;
          this.listBillItem[index].note = item.note;
          this.listBillItem[index].discountType = item.discountType;
          this.listBillItem[index].discountProgramId = item.discountProgramId;
        }
      });
      // KHÔNG iterate `item.vouchers` để gọi reCalVoucherBillItem ở đây.
      // Lý do: khi xoá voucher, BillItem đã emit 'updateVoucher' RIÊNG (kích hoạt
      // reCalVoucherBillItem cho voucher BỊ XOÁ — recompute đúng items chung voucherId).
      // Nếu ở đây iterate remaining vouchers và recompute, sẽ gây side-effect khi xoá
      // regular voucher trước cumulative voucher: recompute cumulative → tier hiện tại
      // không match qty → newCash=0 → discount drop thêm oldCash → voucher.voucherAmount
      // bị reset về 0 → lần xoá cumulative kế tiếp không có tiền để trừ (bug "lúc lỗi
      // lúc không" phụ thuộc thứ tự xoá).
      this.$forceUpdate();
    },
    showChangeGiftModal(billItemId) {
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.listProductVariant = billItem
        ? billItem.listProductVariant
        : [];
      this.selectedBillItem.productId = billItem ? billItem.productId : null;
      this.selectedBillItem.billItemId = billItem.id;
      setTimeout(() => {
        this.$refs['change-gift-modal'].showModal();
      }, TIME_TRIGGER);
    },
    onChangeGift(productId) {
      const productSelected = this.selectedBillItem.listProductVariant.find(
        (variant) => variant.productId === productId,
      );
      const billItem = this.listBillItem.find(
        (item) => item.id === this.selectedBillItem.billItemId,
      );
      billItem.productId = productSelected.productId;
      billItem.name = productSelected.productName;
      billItem.productNameVat = productSelected.productNameVat;
    },
    showNoteModal(billItemId) {
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.note = billItem ? billItem.note : '';
      this.selectedBillItem.billItemId = billItemId;
      setTimeout(() => {
        this.$refs['bill-note-modal'].showModal();
      }, TIME_TRIGGER);
    },
    onChangeNote(note) {
      const billItem = this.listBillItem.find(
        (item) => item.id === this.selectedBillItem.billItemId,
      );
      billItem.note = note;
    },
    showModalShiftWorkConfig() {
      this.shiftWorkConfigSelected = {
        storeName: this.mainModel.storeName,
        storeId: this.mainModel.storeId,
        ...this.shiftWorkConfig,
      };
    },
    showListImeiModal(billItemId, comboImeiSlot = null) {
      this.selectedBillItem.comboChildIndex = null;
      this.selectedBillItem.comboImeiSlotIndex = null;
      if (comboImeiSlot) {
        return this.showListImeiModalForComboChild(billItemId, comboImeiSlot);
      }
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.productId = billItem ? billItem.productId : null;
      this.selectedBillItem.billItemId = billItem.id;
      setTimeout(() => {
        this.$refs['list-imei-modal'].showModal(
          this.selectedBillItem.productId,
        );
      }, TIME_TRIGGER);
    },
    showListProductBatchModal(billItemId) {
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.productId = billItem ? billItem.productId : null;
      this.selectedBillItem.billItemId = billItem.id;
      this.selectedBillItem.comboChildIndex = null; // chọn lô cho SP chính
      setTimeout(() => {
        this.$refs['list-product-batch-modal'].showModal(
          this.selectedBillItem.productId,
          billItem ? billItem.productBatchStockId : null,
        );
      }, TIME_TRIGGER);
    },
    // Mở picker lô cho 1 SP CON của combo (childIndex trong comboItems, comboBillItemId = dòng combo)
    showListProductBatchModalForComboChild(childIndex, comboBillItemId) {
      const billItem = this.listBillItem.find(
        (item) => item.id === comboBillItemId,
      );
      if (!billItem || !billItem.comboItems || !billItem.comboItems[childIndex])
        return;
      const child = billItem.comboItems[childIndex];
      this.selectedBillItem.productName = child.productName || '';
      this.selectedBillItem.productId = child.productId;
      this.selectedBillItem.billItemId = comboBillItemId;
      this.selectedBillItem.comboChildIndex = childIndex; // đánh dấu đang chọn cho SP con
      setTimeout(() => {
        this.$refs['list-product-batch-modal'].showModal(
          child.productId,
          child.productBatchStockId || null,
        );
      }, TIME_TRIGGER);
    },
    showListImeiModalForComboChild(billItemId, comboImeiSlot) {
      if (!this.isEnabledAttachImeiCombo) return;
      this.selectedBillItem.billItemId = billItemId;
      this.selectedBillItem.productId = comboImeiSlot.productId;
      this.selectedBillItem.productName = comboImeiSlot.productName;
      this.selectedBillItem.comboChildIndex = comboImeiSlot.childIndex;
      this.selectedBillItem.comboImeiSlotIndex = comboImeiSlot.slotIndex;
      setTimeout(() => {
        this.$refs['list-imei-modal'].showModal(
          this.selectedBillItem.productId,
        );
      }, TIME_TRIGGER);
    },
    applyComboChildImei(billItem, imeiCode, selectImeiReason) {
      const { comboChildIndex, comboImeiSlotIndex, productId } =
        this.selectedBillItem;
      this.selectedBillItem.comboChildIndex = null;
      this.selectedBillItem.comboImeiSlotIndex = null;
      const child = (billItem.comboItems || [])[comboChildIndex];
      if (!child || child.productId !== productId) {
        return makeToastFaile('Không tìm thấy sản phẩm con trong combo');
      }
      const currentCodes = Array.isArray(child.imeiCodes)
        ? child.imeiCodes
        : [];
      if (
        currentCodes[comboImeiSlotIndex] !== imeiCode &&
        this.isExistImeiCode(this.listBillItem, imeiCode)
      ) {
        return makeToastFaile('Mã IMEI đã tồn tại trong hóa đơn');
      }
      if (!Array.isArray(child.imeiCodes)) {
        this.$set(child, 'imeiCodes', []);
      }
      if (!Array.isArray(child.imeiReasons)) {
        this.$set(child, 'imeiReasons', []);
      }
      this.$set(child.imeiCodes, comboImeiSlotIndex, imeiCode);
      // Lý do sai FIFO đi kèm từng máy => lưu theo đúng slot của IMEI
      this.$set(child.imeiReasons, comboImeiSlotIndex, selectImeiReason || '');
    },
    applyImei(imeiCode, resonFifo) {
      const billItem = this.listBillItem.find(
        (item) => item.id === this.selectedBillItem.billItemId,
      );
      if (!billItem) return;
      if (
        this.selectedBillItem.comboChildIndex !== null &&
        this.selectedBillItem.comboImeiSlotIndex !== null
      ) {
        return this.applyComboChildImei(billItem, imeiCode, resonFifo);
      }
      billItem.imeiCode = imeiCode;
      billItem.selectImeiReason = resonFifo;
      this.updateExternalImeiForBelongItem({
        billItem: billItem,
        imeiCode: imeiCode,
      });
    },
    applyProductBatchStockCode(productBatchStockId, productBatchStockCode) {
      const index = this.listBillItem.findIndex(
        (item) => item.id === this.selectedBillItem.billItemId,
      );
      if (index === -1) return;
      const childIndex = this.selectedBillItem.comboChildIndex;
      // Chọn lô cho SP CON của combo → gán vào comboItems[childIndex]
      if (
        childIndex !== null &&
        childIndex !== undefined &&
        Array.isArray(this.listBillItem[index].comboItems)
      ) {
        const comboItems = this.listBillItem[index].comboItems.slice();
        comboItems[childIndex] = {
          ...comboItems[childIndex],
          productBatchStockId,
          productBatchStockCode,
        };
        this.$set(this.listBillItem, index, {
          ...this.listBillItem[index],
          comboItems,
        });
        this.selectedBillItem.comboChildIndex = null;
        return;
      }
      // Chọn lô cho SP chính (logic cũ)
      this.$set(this.listBillItem, index, {
        ...this.listBillItem[index],
        productBatchStockId,
        productBatchStockCode,
      });
    },

    setImeiNoForBelongDetailBillIds(productItem) {
      this.updateExternalImeiForBelongItem({
        billItem: productItem,
        imeiCode: productItem.imeiCode,
      });
    },
    async updateExternalImeiForBelongItem({ billItem, imeiCode }) {
      const belongDetailBillItems = this.listBillItem.filter(
        (item) =>
          item.belongBillDetailId === billItem.id && item.belongToWarrantyImei,
      );
      if (
        !belongDetailBillItems ||
        !belongDetailBillItems.length ||
        billItem.billItemType !== BILL_ITEM_TYPE.PRODUCT
      ) {
        return;
      }
      this.setExternalImeiNoIntoBelongBillItems({
        billItem,
        imeiCode,
      });
    },
    setExternalImeiNoIntoBelongBillItems({ billItem, imeiCode }) {
      this.listBillItem.map((item, index) => {
        if (
          item.belongBillDetailId === billItem.id &&
          item.belongToWarrantyImei
        ) {
          this.listBillItem[index].externalImeiNo = imeiCode;
        }
      });
    },
    viewInventory(billItemId) {
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      if (billItem) {
        let nameRouter = '';
        if (billItem.type === 2) {
          nameRouter = 'inventory-detail-imei';
        } else {
          nameRouter = 'inventory-detail';
        }
        const { href } = this.$router.resolve({
          name: nameRouter,
          query: {
            id: billItem.productId,
          },
        });
        window.open(href, '_blank');
      }
    },
    isValidImeiCode(listBillItem) {
      let check = true;
      for (let index = 0; index < listBillItem.length; index++) {
        const element = listBillItem[index];
        if (
          element.type === PRODUCT_TYPE.PRODUCT_IMEI &&
          element.checked === true
        ) {
          if (!element.imeiCode || !element.imeiCode.trim()) {
            check = false;
            break;
          }
        }
      }
      return check;
    },
    isValidProductWarranty(listBillItem) {
      return !listBillItem.some(({ type, warrantyImeiNo }) => {
        return (
          type === PRODUCT_TYPE.PRODUCT_WARRANTY && !warrantyImeiNo?.trim()
        );
      });
    },
    // Trả về tên SP đầu tiên thiếu mã lô (chỉ khi bật quản lý lô cho cửa hàng hiện tại).
    // Áp dụng cho SP thường (non-IMEI) có tiêu thụ tồn: SP chính, hoặc bán kèm/tặng kèm được tick lấy hàng.
    getInvalidProductBatchName(listBillItem) {
      if (!this.isFeatureActive('product-batch-stock')) return null;
      for (const item of listBillItem) {
        const isMain = item.billItemType === BILL_ITEM_TYPE.PRODUCT;
        const isTakenExtra =
          (item.billItemType === BILL_ITEM_TYPE.PRODUCT_PROMTION ||
            item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS) &&
          item.checked === true;
        if (!isMain && !isTakenExtra) continue;
        // Combo: kiểm từng SP CON phụ kiện phải có lô (con IMEI/dịch vụ bỏ qua). Chỉ bắt SP con
        // thuộc diện quản lý theo lô (isBatchStockProduct do API search trả); item load sẵn không có
        // cờ => bỏ qua ở FE, BE enforce khi lưu (tránh chặn nhầm SP ngoài danh mục / chưa có lô).
        if (item.comboItems && item.comboItems.length) {
          const invalidChild = item.comboItems.find(
            (child) =>
              child.productType === PRODUCT_TYPE.PRODUCT &&
              child.isBatchStockProduct &&
              !child.productBatchStockId,
          );
          if (invalidChild)
            return invalidChild.productName || invalidChild.name || item.name;
          continue;
        }
        // SP thường phụ kiện
        if (
          item.type === PRODUCT_TYPE.PRODUCT &&
          item.isBatchStockProduct &&
          !item.productBatchStockId
        ) {
          return item.name;
        }
      }
      return null;
    },
    onSubmit: async function (mode = 'save') {
      this.onSubmiting = true;
      const listProductsHaveZeroQuantity = this.listBillItem.filter(
        (item) => Number(item.quantity) === 0,
      );
      if (listProductsHaveZeroQuantity.length) {
        this.onSubmiting = false;
        return makeToastFaile('Số lượng các sản phẩm phải lớn hơn 0');
      }
      if (!this.mainModel.storeId) {
        this.onSubmiting = false;
        return makeToastFaile('Vui lòng chọn cửa hàng!');
      }
      if (!this.listBillItem.length) {
        this.onSubmiting = false;
        return makeToastFaile('Bạn chưa chọn sản phẩm nào');
      }
      if (!this.isValidImei) {
        this.onSubmiting = false;
        //kt lại 1 lần nữa xem IMEI có hợp lệ ko
        makeToastFaile('Mã IMEI không hợp lệ để bán!');
        this.isValidImei = true;
        return;
      }
      if (!this.isValidImeiCode(this.listBillItem)) {
        this.onSubmiting = false;
        return makeToastFaile('Vui lòng nhập IMEI cho sản phẩm IMEI');
      }
      const comboImeiError = validateComboImei(this.listBillItem, {
        enabled: this.isEnabledAttachImeiCombo,
      });
      if (comboImeiError) {
        this.onSubmiting = false;
        return makeToastFaile(comboImeiError);
      }
      if (!this.isValidProductWarranty(this.listBillItem)) {
        this.onSubmiting = false;
        return makeToastFaile('Vui lòng nhập IMEI cho sản phẩm bảo hành');
      }
      const invalidBatchProductName = this.getInvalidProductBatchName(
        this.listBillItem,
      );
      if (invalidBatchProductName) {
        this.onSubmiting = false;
        return makeToastFaile(
          `Vui lòng chọn mã lô cho sản phẩm: ${invalidBatchProductName}`,
        );
      }
      if (
        this.prevSubtractPoint !== this.mainModel.subtractPoint &&
        !this.mainModel.isSubtractPointValidated
      ) {
        this.onSubmiting = false;
        return makeToastFaile('Vui lòng xác thực tiêu điểm tích lũy!');
      }
      if (+this.mainModel.totalAmountPoint > +this.totalAmount) {
        this.onSubmiting = false;
        return makeToastFaile(
          'Không được tiêu điểm nhiều hơn giá trị của hóa đơn !!',
        );
      }
      // const moneyMaxUsePoint = +this.totalAmount * (1.5 / 100);
      // if (+this.mainModel.totalAmountPoint > +moneyMaxUsePoint) {
      //   makeToastFaile(
      //     `Không được tiêu điểm quá 1.5% (${convertPrice(
      //       moneyMaxUsePoint,
      //     )}đ) giá trị của hóa đơn !!`,
      //   );
      //   return;
      // }
      if (this.mainModel.otpCodeDmem && !this.isUseDiscountDmem) {
        this.onSubmiting = false;
        return makeToastFaile('Vui lòng xác thực sử dụng chiết khấu D-MEM!');
      }
      if (this.mainModel.couponCode) {
        if (
          this.prevCouponCode !== this.mainModel.couponCode &&
          !this.isValidCoupon
        ) {
          this.onSubmiting = false;
          return makeToastFaile('Vui lòng xác thực mã coupon!');
        }
      }
      if(this.isEnableValidateCustomerDOB){
        if(!this.mainModel.customerModel.customerDOB){
          this.onSubmiting = false;
          return makeToastFaile('Vui lòng nhập ngày sinh khách hàng!');
        }
        const oneYearAgo = moment()
          .subtract(1, 'year')
          .format(YEAR_MONTH_DAY_FORMAT);

        const customerDOB = formatSpecificDate(
          this.mainModel.customerModel.customerDOB,
          DATE_FORMAT,
          YEAR_MONTH_DAY_FORMAT,
        );

        if (!checkIsBeforeTime(customerDOB, oneYearAgo, YEAR_MONTH_DAY_FORMAT)) {
          this.onSubmiting = false;
          return makeToastFaile('Ngày sinh khách hàng không hợp lệ! Số tuổi quá nhỏ để mua hàng!');
        }
      }
      if (this.isEnableValidateCustomerInfo) {
        if (!this.mainModel.customerModel.customerCity) {
          this.onSubmiting = false;
          return makeToastFaile('Vui lòng chọn Tỉnh/Thành phố!');
        }
        if (!this.mainModel.customerModel.customerWard) {
          this.onSubmiting = false;
          return makeToastFaile('Vui lòng chọn Phường/Xã!');
        }
      }
      const billData = this.setBillData();
      // check creditFeeAmount
      if (billData.creditAmount === 0) {
        billData.otherFees = 0;
      }
      /** Cho phép trả góp 0đ nhiều sản phẩm */
      const isEnabledInsZeroMulProduct = this.isFeatureActive(
        'enabled-installment-zero-mul-product',
      );
      if (
        billData.isInterestZero &&
        billData.listBillItem.length > 1 &&
        !isEnabledInsZeroMulProduct
      ) {
        this.onSubmiting = false;
        return makeToastFaile(
          'Chương trình trả góp 0% chỉ áp dụng cho 1 sản phẩm',
        );
      }
      this.onPaymentSubmiting = false;
      const errorPayments = this.validatePayment(billData);
      if (errorPayments.length) {
        this.onPaymentSubmiting = true;
        this.onSubmiting = false;
        return makeToastFailHtml(this, errorPayments);
      }
      if (!billData.customerMobile) {
        this.onSubmiting = false;
        return makeToastFaile('Vui lòng nhập thông tin khách hàng hợp lệ!');
      }
      if (!billData.customerAppellation) {
        this.onSubmiting = false;
        return makeToastFaile('Vui lòng nhập danh xưng khách hàng!');
      }
      if (!this.isValidTaxCode) {
        this.onSubmiting = false;
        return makeToastFaile('Mã số thuế không hợp lệ!');
      }
      if (!this.isValidEmail) {
        this.onSubmiting = false;
        return makeToastFaile('Email không hợp lệ!');
      }
      if (this.totalAmountBeforeDiscount < billData.discountAmount) {
        this.onSubmiting = false;
        return makeToastFaile(
          'Số tiền chiết khấu không nên cao hơn số tiền sản phẩm',
        );
      }
      if (
        (!billData.customerEmail || !isValidEmail(billData.customerEmail)) &&
        billData.sendBillMethod === 'email'
      ) {
        this.onSubmiting = false;
        return makeToastFaile('Email của khách hàng không hợp lệ');
      }
      if (this.isEnabledValidateEmailCustomer) {
        if (!this.validateMultipleEmailCustomer(billData.customerEmail)) {
          this.onSubmiting = false;
          return;
        }
      }
      if (!billData.customerDOB) {
        this.onSubmiting = false;
        return makeToastFaile('Ngày sinh của khách hàng không hợp lệ');
      }
      if (unMaskPrice(billData.installedMoneyAmount) > 0) {
        if (+billData.installmentProgramPrepayAmount < 0) {
          this.onSubmiting = false;
          return makeToastFaile('Số tiền trả trước phải lớn hơn 0');
        }
      }

      if (hasCustomerNameAppellationPrefix(billData.customerName)) {
        const result = await this.popupSwalWarning({
          title: 'Thông báo',
          text: CUSTOMER_NAME_APPELLATION_WARNING_MESSAGE,
        });

        if (!result.isConfirmed) {
          this.onSubmiting = false;
          return;
        }
      }
      if (!this.mainModel.id) {
        if (!this.mainModel.orderId && this.orderNotComplete) {
          await this.showWarningOrderNotComplete(billData);
        } else {
          this.onCallApiCreate(billData);
        }
      } else {
        this.onCallApiUpdate(billData, mode);
      }
    },
    // M7 V3: link ngược Bill ↔ phiếu sửa chữa khi Bill được tạo từ phiếu SC
    // (để UI RepairSlipLink + report truy xuất 2 chiều). Lỗi link KHÔNG chặn flow chính.
    async linkServiceBillToRepairSlip(billId) {
      if (!this.mainModel.repairSlipId || !billId) return;
      try {
        await ApiService.patch(
          `v2/warranty-service/repair-slips/${this.mainModel.repairSlipId}/link-service-bill`,
          { serviceBillId: billId },
        );
      } catch (linkErr) {
        makeToastFaile(
          linkErr?.response?.data?.message
            || 'Không thể liên kết hoá đơn với phiếu sửa chữa!',
        );
      }
    },
    onCallApiCreate: async function (billData) {
      const url = this.mainModel.fromBillNumber
        ? `bills/re-create/${this.mainModel.fromBillNumber}`
        : 'bills/v2';
      await ApiService.post(url, billData)
        .then(async ({ data }) => {
          if (data.status === 1) {
            makeToastSuccess(data.message);
            this.mainModel.billNumber = data.data.billNumber;
            // M7 V3: Bill tạo từ phiếu sửa chữa → link ngược 2 chiều (chi tiết trong method).
            await this.linkServiceBillToRepairSlip(data.data.id);
            this.$router.push({
              path: '/bills',
            });
          } else {
            makeToastFaile(data.message);
            this.onSubmiting = false;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile(err.$error);
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.onSubmiting = false;
        });
    },
    onCallApiUpdate: async function (billData, mode = 'save') {
      await ApiService.put('bills/v2', billData)
        .then(async ({ data }) => {
          if (data.status === 1) {
            makeToastSuccess(data.message);
            if (mode === 'save-print') {
              this.$router.push({
                name: 'print-bill',
                query: { id: billData.billNumber },
              });
            } else {
              this.$router.push({
                path: '/bills',
              });
            }
            this.onSubmiting = false;
          } else {
            makeToastFaile(data.message);
            this.onSubmiting = false;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile(err.$error);
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.onSubmiting = false;
        });
    },
    setBillData() {
      const billItems = this.formatListBillItem();
      this.transferAmount = this.calcPaymentsAmount(this.mainModel.transfer);
      return {
        id: this.mainModel.id,
        billNumber: this.mainModel.billNumber || null,
        storeId: this.mainModel.storeId,
        stockSlipId: this.mainModel.stockSlipId,
        //khach hang
        customerId: this.mainModel.customerModel.customerId,
        customerMobile: this.mainModel.customerModel.customerMobile.trim(),
        customerName: this.mainModel.customerModel.customerName
          ? this.mainModel.customerModel.customerName.trim()
          : null,
        customerAddress: this.mainModel.customerModel.customerAddress,
        customerCity: this.mainModel.customerModel.customerCity,
        customerDistrict: this.mainModel.customerModel.customerDistrict,
        customerWard: this.mainModel.customerModel.customerWard?.id ?? this.mainModel.customerModel.customerWard,
        customerLastName: this.mainModel.customerModel.customerLastName,
        customerAppellation: this.mainModel.customerModel.customerAppellation,
        customerEmail: this.mainModel.customerModel.customerEmail,
        customerDOB: this.mainModel.customerModel.customerDOB,
        orderSourceId: this.mainModel.orderSourceId,
        //khach hang bao hanh
        warrantyCustomerId: this.mainModel.warrantyCustomerModel.customerId,
        warrantyCustomerName: this.mainModel.warrantyCustomerModel.customerName,
        warrantyCustomerPhone:
          this.mainModel.warrantyCustomerModel.customerMobile,
        warrantyCustomerLastName:
          this.mainModel.warrantyCustomerModel.customerLastName,
        //nhan vien
        saleId: this.mainModel.billEmployeeInfo.saleId,
        technicalId: this.mainModel.billEmployeeInfo.technicalId,
        accessoryStaffId: this.mainModel.billEmployeeInfo.accessoryStaffId,
        cashierId: this.mainModel.billEmployeeInfo.cashierId,
        managerId: this.mainModel.billEmployeeInfo.managerId,
        assistantId: this.mainModel.billEmployeeInfo.assistantId,
        customerReceptionId:
          this.mainModel.billEmployeeInfo.customerReceptionId,
        shipperId: this.mainModel.billEmployeeInfo.shipperId,
        //ghi chu
        customerNote: this.mainModel.billNote.customerNote,
        saleNote: this.mainModel.billNote.saleNote,
        warrantyNote: this.mainModel.billNote.warrantyNote,
        //chiet khau
        discountType: this.mainModel.discountType,
        discountAmount: this.mainModel.discountAmount
          ? unMaskPrice(this.mainModel.discountAmount)
          : 0,
        listBillItem: billItems,
        orderId: this.mainModel.orderId,
        // Back-link Bill bán lẻ → phiếu SC. BE setBillModel persist; FE còn gọi tiếp
        // link-service-bill để set bi-directional (Bill.repairSlipId ↔ PSC.serviceBillId).
        repairSlipId: this.mainModel.repairSlipId || null,
        //hoa don do
        vatCompanyName: this.mainModel.vatInvoice.companyName,
        vatCompanyAddress: this.mainModel.vatInvoice.companyAddress,
        vatCompanyType: this.mainModel.vatInvoice.vatCompanyType,
        email: this.mainModel.vatInvoice.email,
        taxCode: this.mainModel.vatInvoice.taxCode,
        //tieu diem
        pointUse: this.mainModel.subtractPoint
          ? unMaskPrice(this.mainModel.subtractPoint)
          : 0,
        isSubtractPointValidated: this.mainModel.isSubtractPointValidated,
        isCountPoint: this.mainModel.isCountPoint,
        //coupon
        isValidCouponCode: this.isValidCoupon,
        couponCode: this.mainModel.couponCode,
        //chuong trinh tra gop
        installmentProgramId: this.getInstallmentProgram.installmentProgramId,
        installmentProgramMonthNo:
          this.getInstallmentProgram.installmentProgramMonthNo,
        installmentProgramPrepayPercent: unMaskPrice(
          this.getInstallmentProgram.installmentProgramPrepayPercent,
        ),
        installmentProgramPrepayAmount:
          unMaskPrice(
            this.getInstallmentProgram.installmentProgramPrepayAmount,
          ) || 0,
        conversionFee: this.calcConversionFee(this.mainModel.installments),
        installments: this.mainModel.installments,
        credits: this.mainModel.credits,
        transfer: this.mainModel.transfer,
        cash: this.mainModel.cash,
        refunds: this.mainModel.refunds,
        //tien mat
        cashAmount: this.calcPaymentsAmount(this.mainModel.cash),
        cashAccountId: this.mainModel.cash.length
          ? this.mainModel.cash[0].paymentRefId
          : null,
        cashAccountCode: null,
        //chuyen khoan
        transferAmount: this.transferAmount,
        transferAccountID: this.mainModel.transfer.length
          ? this.mainModel.transfer[0].paymentRefId
          : null,
        transferAccountCode: this.mainModel.transfer.length
          ? this.mainModel.transfer[0].paymentCode
          : null,
        transferReferenceCode: this.mainModel.transfer.length
          ? this.mainModel.transfer[0].paymentCode
          : null,
        //quet the
        creditAmount: this.calcPaymentsAmount(this.mainModel.credits),
        creditAccountId: this.mainModel.credits.length
          ? this.mainModel.credits[0].paymentRefId
          : null,
        creditAccountCode: this.mainModel.credits.length
          ? this.mainModel.credits[0].paymentCode
          : null,
        creditCode: this.mainModel.credits.length
          ? this.mainModel.credits[0].paymentCode
          : null,
        creditCardNo: this.mainModel.credits.length
          ? this.mainModel.credits[0].creditCardNo
          : null,
        //phi quet the
        otherFees: this.mainModel.paymentInfo.creditCardFee
          ? unMaskPrice(this.mainModel.paymentInfo.creditCardFee)
          : 0,
        payCreditFeeType: this.mainModel.paymentInfo.payCreditFeeType,
        creditFeeAccountId: this.mainModel.paymentInfo.creditFeeAccountantId,
        creditFeeAcountCode: this.mainModel.paymentInfo.creditFeeAcountCode,
        //tra gop
        installedMoneyAmount: this.calcPaymentsAmount(
          this.mainModel.installments,
        ),
        installMoneyAccountId: this.mainModel.installments.length
          ? this.mainModel.installments[0].paymentRefId
          : null,
        installMoneyAccountCode: this.mainModel.installments.length
          ? this.mainModel.installments[0].paymentCode
          : null,
        customerIndentifyNo: this.mainModel.installments.length
          ? this.mainModel.installments[0].customerIndentifyNo
          : null,
        installMoneyCode: this.mainModel.installments.length
          ? this.mainModel.installments[0].installMoneyCode
          : null,
        isInterestZero: this.getInstallmentInterestZero,
        billType: this.billType,
        isEnableSendBillMethod: this.isEnableSendBillMethod,
        sendBillMethod: this.selectedSendBillMethod,
        otpCodeDmem: this.mainModel.otpCodeDmem || null,
      };
    },
    flattenFlexibleCombo(flexibleCombo) {
      return flexibleCombo.comboItems.map((comboItem) => {
        return {
          id: null,
          productId: comboItem.productId,
          productPrice: unMaskPrice(comboItem.sellingPrice),
          quantity: comboItem.quantity ? unMaskPrice(comboItem.quantity) : 1,
          discountAmount: comboItem.discountAmount
            ? unMaskPrice(comboItem.discountAmount)
            : 0,
          imeiCode: comboItem.imeiCode,
          productType: 1,
          accessoryGroupId: null,
          accessoryGroupCode: '',
          repurchasePrice: 0,
          isGiftTaken: true,
          note: '',
          gifts: [],
          attachs: [],
          discountType: AMOUNT_TYPE.MONEY,
          discountProgramId: null,
          issuedVat: true,
          flexibleComboId: flexibleCombo.flexibleComboId,
          flexibleComboItemId: comboItem.flexibleComboItemId,
        };
      });
    },
    calcConversionFee(installments) {
      return installments.reduce((result, currentItem) => {
        if (currentItem.child && !currentItem.child.deleted) {
          result += currentItem.child.paymentAmount || 0;
        }
        return result;
      }, 0);
    },
    calcPaymentsAmount(items) {
      return items.reduce((result, item) => {
        const unMask = unMaskPrice(item.paymentAmount) || 0;
        return result + Number(unMask);
      }, 0);
    },
    validatePayment(billData) {
      const payments = [
        billData.cash,
        billData.transfer,
        billData.credits,
        billData.installments,
        billData.refunds,
      ];
      const errorMessages = payments.flat().reduce((result, item) => {
        if (item && item.paymentAmount && !item.paymentRefId) {
          result.push(
            `Tài khoản thanh toán số tiền ${convertPrice(
              item.paymentAmount,
            )} không hợp lệ`,
          );
        }
        return result;
      }, []);
      return errorMessages;
    },
    validatePayment2(billData) {
      const amounts = [
        billData.cashAmount,
        billData.transferAmount,
        billData.creditAmount,
        billData.otherFees,
      ];
      const accountIds = [
        billData.cashAccountId,
        billData.transferAccountID,
        billData.creditAccountId,
        billData.creditFeeAccountId,
      ];
      for (let index = 0; index < amounts.length; index++) {
        const amount = amounts[index];
        const accountId = accountIds[index];
        if (parseInt(amount) > 0 && !accountId) {
          this.onPaymentSubmiting = true;
          return false;
        }
      }
      this.onPaymentSubmiting = false;
      return true;
    },
    formatListBillItem() {
      const mainItems = this.listBillItem.filter(
        (billItem) =>
          billItem.billItemType === BILL_ITEM_TYPE.PRODUCT &&
          !billItem.flexibleComboId,
      );
      const flexibleComboBillItems = this.listBillItem.filter(
        (billItem) =>
          billItem.billItemType === BILL_ITEM_TYPE.PRODUCT &&
          billItem.flexibleComboId,
      );
      const giftItems = this.listBillItem.filter(
        (item) => item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS,
      );
      const attachItems = this.listBillItem.filter(
        (item) => item.billItemType === BILL_ITEM_TYPE.PRODUCT_PROMTION,
      );
      const giftItemFormated = this.convertBillItem(giftItems);
      const attachItemFormated = this.convertBillItem(attachItems);
      const mainProductItems = mainItems.map((billItem) => {
        const gifts = giftItemFormated.filter(
          (giftItem) => giftItem.belongBillDetailId === billItem.id,
        );
        const attachs = attachItemFormated.filter(
          (attchItem) => attchItem.belongBillDetailId === billItem.id,
        );
        // Convention với BE: discountAmount = manual + program (KHÔNG gồm voucher).
        // billItem.discount đang là tổng hiển thị UI (manual + program + voucher) nên phải trừ
        // tổng voucher ra trước khi gửi để PUT lại không bị nhân đôi tiền voucher.
        const totalDiscount = billItem.discount ? unMaskPrice(billItem.discount) : 0;
        const voucherSum = (billItem.vouchers || []).reduce(
          (sum, v) => sum + Number(v.voucherAmount || 0),
          0,
        );
        const discountAmountForApi = Math.max(0, Number(totalDiscount) - voucherSum);
        return {
          id: billItem.id || null,
          productId: billItem.productId,
          productPrice: unMaskPrice(billItem.price),
          productName: unMaskPrice(billItem.name),
          quantity: billItem.quantity ? unMaskPrice(billItem.quantity) : 1,
          discountAmount: discountAmountForApi,
          discountAllocation: billItem.discountAllocation,
          imeiCode: billItem.imeiCode,
          productType: billItem.billItemType,
          accessoryGroupId: billItem.accessoryGroupId,
          accessoryGroupCode: billItem.accessoryGroupCode,
          repurchasePrice: billItem.returnPrice
            ? unMaskPrice(billItem.returnPrice)
            : 0,
          isGiftTaken: billItem.checked,
          note: billItem.note,
          gifts: gifts,
          attachs: attachs,
          discountType: billItem.discountType,
          discountProgramId: billItem.discountProgramId,
          issuedVat: billItem.isGetVat,
          merchantId: billItem.merchantId || 1,
          voucherId: billItem.voucherId || null,
          voucherDetailId: billItem.voucherDetailId || null,
          voucherCode: billItem.voucherCode || null,
          externalImeiNo: billItem.externalImeiNo || '',
          customerTypeId: billItem.customerTypeId || null,
          customerDiscountType: billItem.customerDiscountType || null,
          customerDiscountAmount: billItem.customerDiscountAmount || null,
          customerDiscountSellingPrice:
            billItem.customerDiscountSellingPrice || null,
          customerDiscountMaxAmount: billItem.customerDiscountMaxAmount || null,
          vouchers: billItem.vouchers || [],
          discountProgramAmount: 0,
          discountManual: 0,
          productCode: billItem.code,
          selectImeiReason: billItem.selectImeiReason || null,
          productBatchStockId: billItem.productBatchStockId,
          warrantyImeiNo: billItem.warrantyImeiNo || null,
          comboItems: this.mapComboItemsPayload(billItem),
        };
      });
      let flexibleComboProductItems = [];
      flexibleComboBillItems.forEach((flexibleComboBillItem) => {
        const flexibleComboTransformed = this.flattenFlexibleCombo(
          flexibleComboBillItem,
        );
        flexibleComboProductItems = flexibleComboProductItems.concat(
          flexibleComboTransformed,
        );
      });
      return mainProductItems.concat(flexibleComboProductItems);
    },
    mapComboItemsPayload(billItem) {
      return buildBillComboItemsPayload(billItem, {
        enableImei: this.isEnabledAttachImeiCombo,
      });
    },
    convertBillItem(items) {
      return items.map((billItem) => {
        return {
          id: billItem.id || null,
          productId: billItem.productId,
          productPrice: unMaskPrice(billItem.price),
          quantity: billItem.quantity ? unMaskPrice(billItem.quantity) : 1,
          discountAmount: billItem.discount
            ? unMaskPrice(billItem.discount)
            : 0,
          imeiCode: billItem.imeiCode,
          productType: billItem.billItemType,
          accessoryGroupId: billItem.accessoryGroupId,
          accessoryGroupCode: billItem.accessoryGroupCode,
          repurchasePrice: billItem.returnPrice
            ? unMaskPrice(billItem.returnPrice)
            : 0,
          isGiftTaken: billItem.checked,
          note: billItem.note,
          gifts: [],
          attachs: [],
          discountType: AMOUNT_TYPE.MONEY,
          discountProgramId: null,
          issuedVat: billItem.isGetVat,
          belongBillDetailId: billItem.belongBillDetailId,
          merchantId: billItem.merchantId || 1,
          checked: billItem.checked,
          externalImeiNo: billItem.externalImeiNo || '',
          customerTypeId: billItem.customerTypeId,
          customerDiscountType: billItem.customerDiscountType,
          customerDiscountAmount: billItem.customerDiscountAmount,
          customerDiscountSellingPrice: billItem.customerDiscountSellingPrice,
          discountProgramAmount: 0,
          discountManual: 0,
          selectImeiReason: billItem.selectImeiReason || null,
          productBatchStockId: billItem.productBatchStockId,
          comboItems: this.mapComboItemsPayload(billItem),
        };
      });
    },
    getPointRate() {
      ApiService.get(`pointSetting`).then(({ data }) => {
        this.pointSetting.rate = parseInt(data.data.pointRate);
        this.pointSetting.allowRoundToDown =
          data.data.allowAddPointRoundToDown === 1 ? true : false;
      });
    },
    getListOrderSource() {
      ApiService.get(`orderSources/getAll`).then((data) => {
        this.listCustomerSource = data.data.data;
      });
    },
    getOTP(type = OTP_DISCOUNT.POINT) {
      if (type === OTP_DISCOUNT.POINT && !this.onSubmiting) {
        if (this.isUseDiscountDmem) {
          makeToastFaile(
            'Không được sử dụng cùng 1 lúc chiết khấu D-MEM và chiết khấu điểm tiêu dùng',
          );
          return;
        }
        this.onSubmiting = true;
        const otpPayload = {
          customerId: this.mainModel.customerModel.customerId,
          pointUse: unMaskPrice(this.mainModel.subtractPoint),
          phoneNumber: this.mainModel.customerModel.customerMobile,
        };
        ApiService.post('customerOTP/', otpPayload)
          .then(({ data }) => {
            this.onSubmiting = false;
            if (data.status === 1) {
              makeToastSuccess(data.message);
              if (data.data !== null) {
                this.mainModel.otpCode = '123456';
                this.stateOTP = false;
              }
            } else {
              makeToastFaile(data.message);
            }
          })
          .catch((response) => {
            this.onSubmiting = false;
            makeToastFaile(response.$error);
          });
      } else {
        this.onSubmiting = true;
        if (this.mainModel.isSubtractPointValidated) {
          makeToastFaile(
            'Không được sử dụng cùng 1 lúc chiết khấu D-MEM và chiết khấu điểm tiêu dùng',
          );
          return;
        }
        const otpPayload = {
          phoneNumber: this.mainModel.customerModel.customerMobile,
          isCheckBlackList: 1, // bật kiểm tra blacklist
        };
        ApiService.post('customerOTP/generate-otp', otpPayload)
          .then(({ data }) => {
            this.onSubmiting = false;
            if (data.status === 1) {
              makeToastSuccess(data.message);
              if (data.data.otp !== null) {
                this.mainModel.otpCodeDmem = data.data.otp;
                this.stateOTPDmem = false;
              }
            } else {
              makeToastFaile(data.message);
            }
          })
          .catch(({ response }) => {
            this.onSubmiting = false;
            makeToastFaile(response.data.message ?? response.$error);
          });
      }
    },
    checkOTP(type = OTP_DISCOUNT.POINT) {
      if (type === OTP_DISCOUNT.POINT && !this.onSubmiting) {
        this.onSubmiting = true;
        const otpPayload = {
          customerId: this.mainModel.customerModel.customerId,
          pointUse: this.mainModel.subtractPoint
            ? unMaskPrice(this.mainModel.subtractPoint)
            : 0,
          otpCode: this.mainModel.otpCode,
        };
        ApiService.post('customerOTP/checkOTP', otpPayload)
          .then(({ data }) => {
            this.onSubmiting = false;
            if (data.status === 1) {
              if (data.data !== null) {
                if (+data.data > +this.totalAmount) {
                  makeToastFaile(
                    'Không được tiêu điểm nhiều hơn giá trị của hóa đơn !!',
                  );
                  return;
                }
                // const moneyMaxUsePoint = +this.totalAmount * (1.5 / 100);
                // if (+data.data > +moneyMaxUsePoint) {
                //   makeToastFaile(
                //     `Không được tiêu điểm quá 1.5% (${convertPrice(
                //       moneyMaxUsePoint,
                //     )}đ) giá trị của hóa đơn !!`,
                //   );
                //   return;
                // }
                this.mainModel.totalAmountPoint = data.data;
                this.mainModel.isSubtractPointValidated = true;
                this.stateOTP = true;
              }
              makeToastSuccess(data.message);
            } else {
              makeToastFaile(data.message);
              this.stateOTP = false;
            }
          })
          .catch(({ response }) => {
            this.onSubmiting = false;
            makeToastFaile(response.$error);
          });
      } else {
        const otpPayload = {
          customerId: this.mainModel.customerModel.customerId,
          otpCode: this.mainModel.otpCodeDmem,
          isCheckBlackList: 1, // bật kiểm tra blacklist
        };
        ApiService.post('customerOTP/check-generate-otp', otpPayload)
          .then(({ data }) => {
            this.onSubmiting = false;
            if (data.status === 1) {
              makeToastSuccess(data.message);
              if (data.data !== null) {
                this.isUseDiscountDmem = true;
                this.stateOTPDmem = true;
                this.changeDiscountComponentCustomerInfo();
              }
            } else {
              makeToastFaile(data.message);
              this.stateOTPDmem = false;
            }
          })
          .catch(({ response }) => {
            this.onSubmiting = false;
            this.stateOTPDmem = false;
            makeToastFaile(response.data.message ?? response.$error);
          });
      }
    },
    getOrderById() {
      ApiService.query(`orders/${this.mainModel.orderId}`).then((data) => {
        const {
          saleNote,
          customerNote,
          customerId,
          discountAmount,
          discountType,
          transferAmount,
          depositAmount,
          storeId,
          orderItems,
          orderSourceId,
          storeName,
          creditAmount,
          installedMoneyAmount,
          customerShipFee,
          warrantyNote,
          codeShip,
          saleStoreId,
          saleStoreName,
          refundAmount,
        } = data.data.data;
        this.mainModel.billNote.warrantyNote = warrantyNote;
        this.mainModel.storeId = storeId;
        this.mainModel.storeName = storeName;
        this.mainModel.billEmployeeInfo.saleId = saleStoreId;
        this.mainModel.billEmployeeInfo.saleName = saleStoreName;
        this.mainModel.billNote.saleNote = saleNote;
        this.mainModel.billNote.customerNote = customerNote;
        this.mainModel.customerModel.customerId = customerId;
        this.mainModel.discountAmount = discountAmount ? discountAmount : 0;
        this.mainModel.discountType = discountType;
        this.searchStore = storeName;
        this.mainModel.orderSourceId = orderSourceId;
        this.mainModel.moneyTransfered = transferAmount;
        this.mainModel.moneyPaid = depositAmount;
        this.mainModel.moneyCredit = creditAmount;
        this.mainModel.moneyInstallment = installedMoneyAmount;
        this.refundMoneyFromOrder = refundAmount;
        this.mainModel.codeShip = codeShip;
        this.inputSearchProductProp.disabled = false;
        this.mainModel.customerModel.customerMobile =
          data.data.data.customerMobile;
        this.mainModel.customerModel.customerAddress =
          data.data.data.customerAddress;
        this.mainModel.customerModel.customerName = data.data.data.customerName;
        this.mainModel.customerModel.customerCity = data.data.data.customerCity;
        this.mainModel.customerModel.customerWard = data.data.data.customerWard;
        this.mainModel.customerModel.customerDistrict =
          data.data.data.customerDistrict;
        this.mainModel.customerModel.customerEmail =
          data.data.data.customerEmail;
        this.mainModel.customerModel.customerDOB = data.data.data.customerDOB;
        this.mainModel.vatInvoice.companyAddress =
          data.data.data.vatCompanyAddress;
        this.mainModel.vatInvoice.companyName = data.data.data.vatCompanyName;
        this.mainModel.vatInvoice.taxCode = data.data.data.taxCode;
        this.mainModel.vatInvoice.email = data.data.data.email;
        this.mainModel.couponCode = data.data.data.couponCode;
        this.isValidCoupon = data.data.data.couponCode ? true : false;
        this.mainModel.customerShipFee = customerShipFee ? customerShipFee : 0;
        this.mainModel.customerModel.totalPoint = data.data.data.customerPoint;
        this.mainModel.subtractPoint = data.data.data.subtractPoint;
        this.mainModel.totalAmountPoint = data.data.data.subtractPointAmount;
        this.mainModel.isSubtractPointValidated =
          data.data.data.subtractPointAmount > 0 ? true : false;
        // API GET /orders/:id trả về flat array (không phải nested gifts/attachs)
        let flatOrderItems = [];
        const processItem = (orderItem) => {
          let isGiftTaken = orderItem.isGiftTaken === 0 || orderItem.isGiftTaken === false ? false : true;
          const orderDiscount = orderItem.orderItemType === AMOUNT_TYPE.MONEY
            ? (orderItem.discountAmount || 0)
            : 0;
          const voucherTotal = (orderItem.vouchers || []).reduce(
            (sum, v) => sum + Number(v.voucherAmount || 0), 0,
          );
          const itemTotal = (orderItem.productPrice || 0) * (orderItem.quantity || 0);
          const totalDiscount = orderDiscount + voucherTotal;
          flatOrderItems.push({
            id: orderItem.id,
            productId: orderItem.productId,
            name: orderItem.productName,
            code: orderItem.productCode,
            productNameVat: orderItem.productNameVat,
            type: orderItem.productType,
            price: orderItem.productPrice,
            imeiCode: orderItem.imeiCode,
            quantity: orderItem.quantity,
            totalPrice: orderItem.totalAmount,
            discount: totalDiscount > itemTotal ? itemTotal : totalDiscount,
            discountType: AMOUNT_TYPE.MONEY,
            discountProgramId: orderItem.discountProgramId,
            discountProgram: orderItem.discountProgram,
            quantityInStock: orderItem.quantityInStock,
            // HĐ từ đơn: điền sẵn IMEI con combo của đơn, cho sửa như dòng mới (plan §10.5.4)
            comboItems: normalizeComboItems(
              orderItem.productInCombos,
              orderItem.quantity,
              { keepImeiCodes: true, deriveUnitFromImei: false },
            ),
            storeId: storeId,
            deleted: orderItem.deleted,
            billItemType: orderItem.orderItemType,
            returnPrice: orderItem.repurchasePrice
              ? orderItem.repurchasePrice
              : 0,
            checked: isGiftTaken,
            orderItemType: orderItem.orderItemType,
            listAccessoryBonus: [],
            note: orderItem.note ? orderItem.note : '',
            listAccessoryPromotion: orderItem.listAccessoryPromotion
              ? orderItem.listAccessoryPromotion
              : [],
            belongBillDetailId: orderItem.belongOrderDetailId,
            isGetVat: false,
            merchantId: orderItem.merchantId,
            customerTypeId: orderItem.customerTypeId || null,
            customerDiscountType: orderItem.customerDiscountType || null,
            customerDiscountAmount: orderItem.customerDiscountAmount || null,
            customerDiscountSellingPrice:
              orderItem.customerDiscountSellingPrice || null,
            belongToWarrantyImei: orderItem.belongToWarrantyImei || false,
            selectImeiReason: orderItem.selectImeiReason || null,
            warrantyImeiNo: orderItem.warrantyImeiNo || null,
            vouchers: (orderItem.vouchers || []).map((v) => {
              let cv = v.cumluativeValues;
              for (let i = 0; i < 3; i += 1) {
                if (typeof cv !== 'string') break;
                if (!cv) {
                  cv = [];
                  break;
                }
                try {
                  cv = JSON.parse(cv);
                } catch (e) {
                  cv = [];
                  break;
                }
              }
              if (!Array.isArray(cv)) cv = [];
              return {
                voucherId: v.voucherId,
                voucherDetailId: v.voucherDetailId,
                voucherCode: v.voucherCode,
                voucherTypeDiscount: v.voucherTypeDiscount,
                voucherAmount: Math.floor(Number(v.voucherAmount || 0)),
                cumluativeValues: cv,
              };
            }),
            oldVoucherCumluativeValue: {},
            discountManual: 0,
            discountProgramAmount: 0,
          });
        };
        // Sort: sản phẩm chính trước, quà/attach sau
        const sortedItems = [
          ...orderItems.filter(x => x.orderItemType === 1),
          ...orderItems.filter(x => x.orderItemType !== 1),
        ];
        sortedItems.forEach(x => processItem(x));
        this.listBillItem = flatOrderItems;
        this.listBillItem = this.sortListBillItem(this.listBillItem);
        this.inputSearchProductProp.disabled = false;
        this.renderComponent = true;
        this.handlerVoucher();
      });
    },
    // prefill Bill từ phiếu sửa chữa khi KTBH chuyển sang "Hoàn thành" (2026-05-27).
    // Mirror getOrderById nhưng nguồn dữ liệu là RepairSlip + RepairSlipParts.
    // Snapshot mọi linh kiện có giá (price>0) đều lên Hoá đơn bán lẻ.
    async getRepairSlipById(repairSlipId) {
      try {
        const { data } = await ApiService.query(
          `v2/warranty-service/repair-slips/${repairSlipId}`,
        );
        const slip = (data && data.data) || {};
        const store = slip.store || {};
        const parts = Array.isArray(slip.parts) ? slip.parts : [];

        // Customer snapshot (RepairSlip không có city/district/ward → để null)
        this.mainModel.customerModel.customerId = slip.customerId || null;
        this.mainModel.customerModel.customerMobile = slip.customerPhone || '';
        this.mainModel.customerModel.customerName = slip.customerName || '';
        this.mainModel.customerModel.customerAddress = slip.customerAddress || '';
        this.mainModel.customerModel.customerEmail = slip.customerEmail || '';

        // Store snapshot
        this.mainModel.storeId = slip.storeId || null;
        this.mainModel.storeName = store.name || '';
        this.searchStore = store.name || '';

        // Ghi chú để KTBH biết Bill này gắn với phiếu nào
        this.mainModel.billNote.warrantyNote = `Tạo từ phiếu sửa chữa ${slip.slipNumber || repairSlipId}`;

        // Parts → listBillItem. Mọi linh kiện có giá đều lên Hoá đơn bán lẻ (trừ kho XKBL).
        const billable = parts.filter(
          (p) => Number(p.price) > 0 && Number(p.quantity) > 0,
        );

        // Enrich từng part bằng productSearch/search-by-type (cùng API thanh search dùng)
        // rồi build qua BillItemLogicModal y hệt flow onSelectedProduct → đảm bảo shape
        // billItem chính xác như khi KTBH gõ search box (merchantId, quantityInStock,
        // productNameVat, listProductInCombo, customer-discount fields...).
        const items = await Promise.all(billable.map(async (p) => {
          let master = null;
          try {
            const resp = await ApiService.query('productSearch/search-by-type', {
              params: {
                searchProduct: p.productCode || p.productName || '',
                typeSearch: 2,
                storeId: slip.storeId || null,
              },
            });
            const candidates = (resp && resp.data && resp.data.data) || [];
            master = candidates.find(
              (m) => (m.productId || m.id) === p.productId,
            ) || null;
          } catch (e) {
            master = null;
          }

          const qty = Number(p.quantity) || 1;
          const price = Number(p.price) || 0;
          const vatRate = Number(p.vatRate) || 0;

          // Fallback: nếu search không match (vd product đã ẩn / đổi code) → dùng snapshot từ part
          const dataForModal = master || {
            productId: p.productId,
            productName: p.productName,
            productNameVat: p.productName,
            productCode: p.productCode,
            productCategory: null,
            sellingPrice: price,
            listedPrice: price,
            quantityInStock: 0,
            merchantId: 1,
            listProductInCombo: [],
            listAccessoryPromotion: [],
            vouchers: [],
            // Carry cờ quản lý theo lô (nếu part mang sẵn) — BillItemLogicModal đọc data.isBatchStockProduct.
            isBatchStockProduct: p.isBatchStockProduct || false,
          };

          const billItem = new BillItemLogicModal({
            data: dataForModal,
            storeId: slip.storeId || null,
            programPrice: price, // KTBH có thể đã chỉnh giá trên slip → ưu tiên giá part
            productType: Number(p.productType),
            imeiCode: '',
          });
          billItem.quantity = qty;
          billItem.isGetVat = vatRate > 0;
          billItem.discountType = AMOUNT_TYPE.MONEY;
          // BE bug: BillItemLogicModal default discountProgramId=-1, khi BE chạy
          // discountProgram#updateUsedWhenCreateBill sẽ +productId (UUID) → NaN
          // → query WHERE productId=NaN → SequelizeDatabaseError.
          // Set null để bypass (BE: `if (!discountProgramId) continue;`).
          billItem.discountProgramId = null;
          return billItem;
        }));
        this.listBillItem = this.sortListBillItem(items);
        this.inputSearchProductProp.disabled = false;
        this.renderComponent = true;
      } catch (err) {
        const message = (err && err.response && err.response.data && err.response.data.message)
          || 'Tải dữ liệu phiếu sửa chữa thất bại!';
        makeToastFaile(message);
        this.renderComponent = true;
      }
    },
    async getBillByIdAndReRenderBillPayment() {
      await this.getBillById();
      this.reRenderComponentBillPayment++;
    },
    async getBillById() {
      this.onLoading = true;
      await ApiService.get(`bills/${this.mainModel.billNumber}`).then(
        async (response) => {
          if (response.data.status === 0) {
            return makeToastFaile('Tải thông tin hóa đơn thất bại!');
          }
          const dataRes = response.data.data;
          const {
            id,
            storeId,
            storeName,
            storeShortName,
            siteCode,
            saleNote,
            customerNote,
            warrantyNote,
            customerId,
            discountAmount,
            discountType,
            orderSourceId,
            customerShipFee,
            codeShip,
            cashAmount,
            cashAccountId,
            cashAccName,
            cashAccountCode,
            transferAmount,
            transferAccountId,
            transferAccName,
            transferAccountCode,
            transferReferenceCode,
            creditAmount,
            creditAccountId,
            creditAccName,
            creditAccountCode,
            creditCardNo,
            creditCode,
            otherFees,
            payCreditFeeType,
            creditFeeAcountId,
            creditFeeAccName,
            creditFeeAcountCode,
            installedMoneyAmount,
            installMoneyAccountId,
            installmentAccName,
            customerIndentifyNo,
            installMoneyCode,
            depositAmount,
            transferFromOrder,
            moneyCredit,
            moneyInstallment,
            pointToMoney,
            subtractPoint,
            couponCode,
            billItems,
            editable,
            isSubtractPointValidated,
            isCountPoint,
            payments,
            createdAt,
            tradeIn,
            customerAppellation,
            billVat,
            refundMoneyFromOrder,
          } = dataRes;
          this.tradeIn = { ...tradeIn };
          this.mainModel.id = id;
          // M7 V2: liên kết ngược về phiếu sửa chữa (Bill auto-tạo từ flow Dịch vụ bảo hành)
          this.mainModel.repairSlipId = dataRes.repairSlipId || null;
          this.mainModel.storeId = storeId;
          this.mainModel.storeName = storeName;
          this.mainModel.storeShortName = storeShortName;
          this.mainModel.siteCode = siteCode;
          this.mainModel.stockSlipId = this.tradeIn.stockSlip
            ? this.tradeIn.stockSlip.id
            : '';
          this.mainModel.billNote.warrantyNote = warrantyNote;
          this.mainModel.billNote.saleNote = saleNote;
          this.mainModel.billNote.customerNote = customerNote;
          this.mainModel.customerModel.customerId = customerId;
          this.mainModel.customerModel.customerMobile = dataRes.customerPhone;
          this.mainModel.customerModel.customerAddress =
            dataRes.customerAddress;
          this.mainModel.customerModel.customerName = dataRes.customerName;
          this.mainModel.customerModel.customerCity = dataRes.customerCity;
          this.mainModel.customerModel.customerWard = dataRes.customerWard;
          this.mainModel.customerModel.customerDistrict =
            dataRes.customerDistrict;
          this.mainModel.customerModel.totalPoint = dataRes.customerPoint;
          this.mainModel.customerModel.customerAppellation =
            customerAppellation;
          this.mainModel.customerModel.customerEmail = dataRes.customerEmail;
          this.mainModel.customerModel.customerDOB = dataRes.customerDOB;
          this.mainModel.orderSourceId = orderSourceId;
          this.mainModel.discountAmount = discountAmount ? discountAmount : 0;
          this.mainModel.discountType = discountType;
          this.mainModel.codeShip = codeShip;
          this.mainModel.customerShipFee = customerShipFee
            ? customerShipFee
            : 0;
          this.mainModel.billEmployeeInfo.saleId = dataRes.saleId;
          this.mainModel.billEmployeeInfo.saleName = dataRes.saleName;
          this.mainModel.billEmployeeInfo.technicalId = dataRes.technicalId;
          this.mainModel.billEmployeeInfo.technicalName = dataRes.techName;
          this.mainModel.billEmployeeInfo.cashierId = dataRes.cashierId;
          this.mainModel.billEmployeeInfo.cashierName = dataRes.cashierName;
          this.mainModel.billEmployeeInfo.managerId = dataRes.managerId;
          this.mainModel.billEmployeeInfo.managerName = dataRes.managerName;
          this.mainModel.billEmployeeInfo.assistantId = dataRes.assistantId;
          this.mainModel.billEmployeeInfo.assistantName = dataRes.assistantName;
          this.mainModel.billEmployeeInfo.customerReceptionId =
            dataRes.customerReceptionId;
          this.mainModel.billEmployeeInfo.customerReceptionName =
            dataRes.customerReceptionName;
          this.mainModel.billEmployeeInfo.accessoryStaffId =
            dataRes.accessoryStaffId;
          this.mainModel.billEmployeeInfo.accessoryStaffName =
            dataRes.accessoryStaffName;
          this.mainModel.billEmployeeInfo.shipperId = dataRes.shipperId;
          this.mainModel.billEmployeeInfo.shipperName = dataRes.shipperName;
          this.mainModel.billVat = billVat;
          this.mainModel.paymentInfo.cashAmount = cashAmount;
          this.mainModel.paymentInfo.cashAccountId = cashAccountId;
          this.mainModel.paymentInfo.cashAccountantName = cashAccName;
          this.mainModel.paymentInfo.cashAccountCode = cashAccountCode;
          this.mainModel.paymentInfo.transferAmount = transferAmount;
          this.mainModel.paymentInfo.transferAccountantId = transferAccountId;
          this.mainModel.paymentInfo.transferAccountantName = transferAccName;
          this.mainModel.paymentInfo.transferAccountCode = transferAccountCode;
          this.mainModel.paymentInfo.transferReferenceCode =
            transferReferenceCode;
          this.mainModel.paymentInfo.creditAmount = creditAmount;
          this.mainModel.paymentInfo.creditAccountantId = creditAccountId;
          this.mainModel.paymentInfo.creditAccountCode = creditAccountCode;
          this.mainModel.paymentInfo.creditAccountantName = creditAccName;
          this.mainModel.paymentInfo.creditCardNo = creditCode;
          this.mainModel.paymentInfo.creditCardCode = creditCardNo;
          this.mainModel.paymentInfo.creditCardFee = otherFees;
          this.mainModel.paymentInfo.payCreditFeeType = payCreditFeeType;
          this.mainModel.paymentInfo.creditFeeAccountantId = creditFeeAcountId;
          this.mainModel.paymentInfo.creditFeeAcountCode = creditFeeAcountCode;
          this.mainModel.paymentInfo.creditFeeAccountantName = creditFeeAccName;
          this.mainModel.paymentInfo.installedMoneyAmount =
            installedMoneyAmount;
          this.mainModel.paymentInfo.installMoneyAccountId =
            installMoneyAccountId;
          this.mainModel.paymentInfo.installmentAccountName =
            installmentAccName;
          this.mainModel.paymentInfo.customerIndentifyNo = customerIndentifyNo;
          this.mainModel.paymentInfo.installmentCode = installMoneyCode;
          this.mainModel.warrantyCustomerModel.customerId =
            dataRes.warrantyCustomerId;
          this.mainModel.warrantyCustomerModel.customerName =
            dataRes.warrantyCustomerName;
          this.mainModel.warrantyCustomerModel.customerMobile =
            dataRes.warrantyCustomerPhone;
          this.mainModel.warrantyCustomerModel.customerLastName =
            dataRes.warrantyCustomerLastName;
          this.mainModel.orderId = dataRes.orderId;
          this.mainModel.moneyTransfered = transferFromOrder;
          this.mainModel.moneyPaid = depositAmount;
          this.mainModel.moneyCredit = moneyCredit;
          this.mainModel.moneyInstallment = moneyInstallment;
          this.mainModel.totalAmountPoint = pointToMoney;
          this.mainModel.subtractPoint = subtractPoint;
          this.prevSubtractPoint = subtractPoint;
          this.mainModel.isSubtractPointValidated = isSubtractPointValidated;
          this.mainModel.isCountPoint = isCountPoint;
          this.mainModel.couponCode = couponCode;
          this.prevCouponCode = couponCode;
          this.mainModel.vatInvoice.companyName = dataRes.companyName;
          this.mainModel.vatInvoice.companyAddress = dataRes.vatCompanyAddress;
          this.mainModel.vatInvoice.vatCompanyType = dataRes.vatCompanyType;
          this.mainModel.vatInvoice.email = dataRes.email;
          this.mainModel.vatInvoice.taxCode = dataRes.taxCode;
          this.mainModel.companyBill = dataRes.taxCode ? true : false;
          this.mainModel.billNote.customerNote = dataRes.customerNote;
          this.mainModel.billNote.saleNote = dataRes.saleNote;
          this.mainModel.billNote.warrantyNote = dataRes.warrantyNote;
          this.mainModel.editable = editable;
          this.mainModel.billCreatedAt = createdAt;
          this.mockupCustomerForBill.customerId = dataRes.customerId;
          this.mockupCustomerForBill.customerName = dataRes.customerName;
          this.mainModel.installments = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.INSTALLMENT,
          );
          this.mainModel.credits = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.CREDIT,
          );
          this.mainModel.transfer = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.TRANSFER,
          );
          this.mainModel.cash = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.CASH,
          );
          this.mainModel.refunds = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.REFUND,
          );
          const flexibleComboBillItems = billItems.filter(
            (billItem) => billItem.flexibleComboId,
          );
          const normalBillItems = billItems.filter(
            (billItem) => !billItem.flexibleComboId,
          );
          const flexibleComboItems = this.combineFlexibleCombo(
            flexibleComboBillItems,
          );
          this.isInterestZero = false;
          this.refundMoneyFromOrder = refundMoneyFromOrder;
          this.$store.dispatch(SET_INTEREST, false);
          if (dataRes.installmentProgram) {
            await this.$nextTick();
            this.$store.dispatch(SET_INSTALLMENT_PROGRAM, {
              details: [],
              installmentProgramId: dataRes.installmentProgram.id,
              installmentProgramName: dataRes.installmentProgram.name,
              installmentProgramMonthNo: dataRes.installmentProgramMonthNo,
              installmentProgramPrepayPercent:
                dataRes.installmentProgramPrepayPercent,
              installmentProgramPrepayAmount:
                dataRes.installmentProgramPrepayAmount,
              monthNo: dataRes.installmentProgram.monthNo,
              prepayPercent: dataRes.installmentProgram.prepayPercent,
              conversionFeePercent:
                dataRes.installmentProgram.conversionFeePercent,
              conversionFeeMethod:
                dataRes.installmentProgram.conversionFeeMethod,
            });
          }
          // let totalVoucherAmount = 0;
          this.listBillItem = normalBillItems.map((billItem) => {
            if (!billItem.vouchers.length && billItem.voucherId) {
              // cập nhật cho version cũ
              // nếu billItem có voucher đã được apply trước đó (khi chưa có luồng apply nhiều voucher)
              // thì push vào vouchers để chạy luồng mới
              billItem.vouchers.push({
                voucherId: billItem.voucherId,
                voucherTypeDiscount: DISCOUNT_AMOUNT_TYPE.MONEY,
                voucherAmount: billItem.discountAmount,
                voucherCode: billItem.voucherCode,
                voucherDetailId: billItem.voucherDetailId,
                cumluativeValues: billItem.cumluativeValues,
              });
            }
            const discountProgramAmount = billItem.discountProgram
              ? billItem.discountProgram.discountProgramAmount
              : 0;
            return {
              id: billItem.id,
              productId: billItem.productId,
              name: billItem.productName,
              productNameVat: billItem.productNameVat,
              code: billItem.productCode,
              price: billItem.productPrice,
              type: billItem.productType,
              quantity: billItem.quantity,
              imeiCode: billItem.imeiCode,
              totalPrice:
                billItem.quantity * billItem.productPrice -
                billItem.discountAmount,
              discount: billItem.discountAmount,
              discountAllocation: billItem.discountAllocation,
              // Dòng đã lưu (sửa / tạo lại HĐ): giữ IMEI con combo, khóa đổi SL (D4)
              comboItems: normalizeComboItems(
                billItem.listProductInCombo,
                billItem.quantity,
                { keepImeiCodes: true },
              ),
              isPersisted: true,
              billItemType: billItem.billItemType,
              checked:
                billItem.isGiftTaken === null ? true : billItem.isGiftTaken,
              returnPrice: billItem.repurchasePrice
                ? billItem.repurchasePrice
                : 0,
              accessoryGroupId: billItem.accessoryGroupId
                ? billItem.accessoryGroupId
                : '',
              accessoryGroupCode: billItem.accessoryGroupCode
                ? billItem.accessoryGroupCode
                : '',
              note: billItem.note,
              belongBillDetailId: billItem.belongBillDetailId,
              listAccessoryPromotion: billItem.listProductPromotion,
              quantityInStock: billItem.quantityInStock,
              storeId: storeId,
              discountType: parseInt(billItem.discountType),
              discountProgramId: billItem.discountProgramId,
              isGetVat: billItem.issuedVat === 1 ? true : false,
              disabledByInstallmentProgram: this.applyInstallmentProgram
                ? true
                : false,
              isInstallmentProgramProduct: this.applyInstallmentProgram
                ? true
                : false,
              sellingPrice: billItem.sellingPrice || 0,
              listedPrice: billItem.listedPrice || 0,
              flexibleComboId: billItem.flexibleComboId || null,
              merchantId: billItem.merchantId || 1,
              voucherId: billItem.voucherId || null,
              voucherDetailId: billItem.voucherDetailId || null,
              voucherCode: billItem.voucherCode || null,
              voucherCumluativeValues: billItem.cumluativeValues || [],
              warrantyMonthNo: billItem.warrantyMonthNo || '',
              warrantyPhone: billItem.warrantyPhone || '',
              warrantyAddress: billItem.warrantyAddress || '',
              warrantyDescription: billItem.warrantyDescription || '',
              externalImeiNo: billItem.externalImeiNo || '',
              belongToWarrantyImei: billItem.belongToWarrantyImei || false,
              allowViewFullExternalImeiNo:
                billItem.allowViewFullExternalImeiNo || false,
              customerTypeId: billItem.customerTypeId,
              customerDiscountType: billItem.customerDiscountType,
              customerDiscountAmount: billItem.customerDiscountAmount,
              customerDiscountSellingPrice:
                billItem.customerDiscountSellingPrice,
              customerDiscountMaxAmount: billItem.customerDiscountMaxAmount,
              isSoftwareProduct: billItem.isSoftwareProduct || false,
              // Normalize từng voucher khi load:
              // 1. Floor voucherAmount — chống data cũ lưu decimal.
              // 2. Parse cumluativeValues về ARRAY thật (giải double/triple-encoded JSON).
              //    Trước đây BE có bug double-stringify nên một số bill cũ trong DB lưu
              //    `"\"[{...}]\""` (nested). Parse 1 lần ra string, parse tiếp ra array.
              //    Mọi code FE sau đó nhận array nguyên gốc, không bao giờ fail tier match.
              vouchers: (billItem.vouchers || []).map((v) => {
                let cv = v.cumluativeValues;
                // Tối đa parse 3 layer (đề phòng nested sâu).
                for (let i = 0; i < 3; i += 1) {
                  if (typeof cv !== 'string') break;
                  if (!cv) {
                    cv = [];
                    break;
                  }
                  try {
                    cv = JSON.parse(cv);
                  } catch (e) {
                    cv = [];
                    break;
                  }
                }
                if (!Array.isArray(cv)) cv = [];
                return {
                  ...v,
                  voucherAmount: Math.floor(Number(v.voucherAmount || 0)),
                  cumluativeValues: cv,
                };
              }),
              discountProgram: billItem.discountProgram,
              discountProgramAmount:
                discountProgramAmount > 0 ? discountProgramAmount : 0,
              // chiết khấu tay sẽ = tông chiết khấu - tổng chiết khấu voucher - tổng chiết khấu chương trình
              discountManual: 0,
              // discountManual: discountManual > 0 ? discountManual : 0,
              isVieonProduct: billItem.isVieonProduct || false,
              statusVieon: billItem.statusVieon || false,
              selectImeiReason: billItem.selectImeiReason || null,
              oldVoucherCumluativeValue: {},
              productBatchStockId: billItem.productBatchStockId,
              productBatchStockCode: billItem.productBatchStockCode,
              warrantyImeiNo: billItem.warrantyImeiNo || null,
            };
          });
          this.listBillItem = this.listBillItem.concat(flexibleComboItems);
          this.listBillItem = this.sortListBillItem(this.listBillItem);
          this.handlerVoucher();
          this.inputSearchProductProp.disabled = false;
          if (this.$route.name === 'add-bill') {
            this.mainModel.id = null;
            this.mainModel.billNumber = null;
            this.mainModel.storeDisable = true;
          } else {
            this.pageTitle = `#${this.mainModel.billNumber} - Ngày: ${dataRes.createdAt}`;
          }
          setTimeout(() => {
            this.renderComponent = true;
          }, TIME_TRIGGER);
          this.fetchStoreByUser();
          this.isUseDiscountDmem = this.isValidDiscountDmem;
          // if (this.isInterestZero) {
          //   this.fetchProgramByProductIds(this.isInterestZero);
          // }
          // await this.fetchDiscountCustomerType();
          // if (this.customerDiscount) {
          //   this.handlerDiscountCustomerType();
          // }
        },
      ).finally(() => {
        this.onLoading = false;
      });
    },
    checkPermission: function (condition) {
      return localData.checkPermission(condition);
    },
    handleFileUpload(event) {
      // this.linkHref = "";
      this.fileAttach.files = event.target.files;
    },
    //Func to truncate long filenames to short ones to display
    ftruncate(n) {
      // var len = 10;
      var ext = n.substring(n.lastIndexOf('.') + 1, n.length).toLowerCase();
      var filename = n.replace('.' + ext, '');
      return filename + '.' + ext;
    },
    viewHistoryDetail(item) {
      const { href } = this.$router.resolve({
        name: 'detail-bill-history',
        query: { id: item.id },
      });
      window.open(href, '_blank');
    },
    fetchBillHistory: async function () {
      const params = {
        //  loại hóa đơn
        type: 2,
      };
      await ApiService.setHeader();
      await ApiService.query(
        '/histories/getByReferenceId/' + this.mainModel.billNumber,
        {
          params,
        },
      ).then((res) => {
        res.data.data.map((x) => {
          let data = {
            id: x.id,
            type: x.type,
            referenceId: x.referenceId,
            action: x.action,
            description: x.description,
            originalValue: x.originalValue,
            newValue: x.newValue,
            updatedBy: x.updatedBy,
            createdAt: moment(String(x.createdAt)).format('DD/MM/YYYY HH:mm'),
            updatedAt: moment(x.updatedAt).format('DD/MM HH:mm'),
          };
          this.histories.push(data);
        });
      });
    },
    onUpdatePayment(paymentInfo) {
      this.mainModel.paymentInfo = cloneDeep(paymentInfo);
    },
    onUpdatePaymentV2(items = [], type) {
      let totalAmount = 0;
      let payments = items.reduce((result, current) => {
        totalAmount += +unMaskPrice(current.paymentAmount);
        result.push({
          ...current,
          paymentAmount: unMaskPrice(current.paymentAmount),
        });
        return result;
      }, []);
      switch (type) {
        case PAYMENT_TYPE.INSTALLMENT: {
          if (!totalAmount) {
            this.$store.dispatch(PURGE_INSTALLMENT_PROGRAM);
            this.$store.dispatch(SET_INTEREST, false);
            payments = payments.map((item) => {
              return {
                ...item,
                child: {
                  id: v4(),
                  paymentRefId: null,
                  paymentRefCode: null,
                  paymentName: null,
                  paymentAmount: null,
                  paymentCode: null,
                  transactionId: null,
                  paymentOptionType: null,
                },
              };
            });
          }
          this.mainModel.installments = payments;
          break;
        }
        case PAYMENT_TYPE.CREDIT: {
          this.mainModel.credits = payments;
          break;
        }
        case PAYMENT_TYPE.TRANSFER: {
          this.mainModel.transfer = payments;
          break;
        }
        case PAYMENT_TYPE.CASH: {
          this.mainModel.cash = payments;
          break;
        }
        case PAYMENT_TYPE.REFUND: {
          this.mainModel.refunds = payments;
          break;
        }
      }
    },
    async onUpdateCustomer(customerInfo) {
      this.mainModel.customerModel = cloneDeep(customerInfo);
      if (
        this.mainModel.id &&
        customerInfo.customerId !== this.mockupCustomerForBill.customerId
      ) {
        // this.customerDiscount = null;
        // // // this.debounceInputDiscountCustomerType();
        // await this.fetchDiscountCustomerType();
        // if (this.customerDiscount) {
        //   this.handlerDiscountCustomerType(this.listBillItem);
        // }
        await this.changeDiscountComponentCustomerInfo();
        this.mainModel.customerModel.customerId =
          this.mockupCustomerForBill.customerId;
      }
    },
    onChangeSubtractPoint() {
      if (this.prevSubtractPoint !== this.mainModel.subtractPoint) {
        this.mainModel.isSubtractPointValidated = false;
      }
      // else {
      //   this.mainModel.isSubtractPointValidated = true;
      // }
    },
    fetchStoreByUser() {
      ApiService.get(`stores/get-by-user`).then(({ data }) => {
        if (data.status === 1) {
          this.inputSearchProductProp.disabled = false;
          if (!this.mainModel.billEmployeeInfo.saleId) {
            this.mainModel.billEmployeeInfo.saleId = data.data.id;
            this.mainModel.billEmployeeInfo.saleName = data.data.employeeName;
          }
          if (
            data.data.jobTitleId === 6 &&
            !this.mainModel.billEmployeeInfo.cashierId
          ) {
            this.mainModel.billEmployeeInfo.cashierId = data.data.id;
            this.mainModel.billEmployeeInfo.cashierName =
              data.data.employeeName;
          }
          const stores = data.data.stores;
          if (stores.length === 1 && !this.mainModel.storeId) {
            this.mainModel.storeId = stores[0].id;
            this.mainModel.storeName = stores[0].name;
            this.mainModel.storeDisable = false;
            this.fetchShiftWorkConfig();
          }
          if (this.mainModel.id) {
            this.fetchShiftWorkConfig();
            this.mainModel.storeDisable = true;
          }
        }
      });
    },
    fetchCustomerCransaction(customerTransaction) {
      this.orderNotComplete = customerTransaction.orderNotComplete;
    },
    showWarningOrderNotComplete: function (billData) {
      Swal.fire({
        title: 'Cảnh báo đơn hàng!',
        text: 'Khách hàng có đơn hàng chưa hoàn thành, bạn có chắc muốn tạo hóa đơn mới cho khách hàng này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Tạo mới',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
        position: 'top',
      }).then((result) => {
        if (result.value) {
          this.onCallApiCreate(billData);
        } else {
          this.onSubmiting = false;
        }
      });
    },
    linkToWarranty(id) {
      this.$router.push({
        name: 'add-import-warranty',
        query: { refId: id },
      });
    },
    showActiveModal(imeiCode) {
      this.$refs['active-imei-modal'].showModal(
        imeiCode,
        this.mainModel.customerModel.customerMobile,
        this.mainModel.storeName,
        this.mainModel.siteCode,
      );
    },
    fetchProgramByProductIds(isInterestZero) {
      const items = cloneDeep(this.listBillItem);
      const productIds = items.map((item) => item.productId);
      if (!productIds.length) {
        return;
      }
      const params = {
        productIds: productIds,
        isInterestZero: isInterestZero,
      };
      ApiService.query('installment-programs/product-ids', {
        params: params,
      }).then((response) => {
        const { data } = response.data;
        let programs = [];
        items.map((item, index) => {
          const productFinded = data.find(
            (product) => product.productId === item.productId,
          );
          if (productFinded) {
            item.sellingPrice = productFinded.programPrice;
            // item.price = productFinded.programPrice;
            programs = programs.concat(productFinded.programs);
            this.$set(this.listBillItem, index, item);
          }
        });
        this.selectInstallmentProgram(isInterestZero, programs);
      });
    },
    // selectInstallmentProgram(isInterestZero, programs) {
    selectInstallmentProgram(isInterestZero, programs) {
      if (isInterestZero) {
        /** Nếu chưa chọn program thì sẽ lấy program đầu tiên */
        if (!this.getInstallmentProgram.installmentProgramId) {
          const firstChoiceProram = programs[0];
          return this.$store.dispatch(SET_INSTALLMENT_PROGRAM, {
            installmentProgramId: null,
            installmentProgramName: null,
            monthNo: firstChoiceProram.monthNo.split(',').map(Number),
            installmentProgramMonthNo: null,
            installmentProgramPrepayPercent:
              this.getInstallmentProgram.installmentProgramPrepayPercent ||
              null,
            installmentProgramPrepayAmount:
              convertPrice(
                this.calcPaymentsAmount([
                  ...this.mainModel.cash,
                  ...this.mainModel.transfer,
                  ...this.mainModel.credits,
                ]),
              ) || 0,
            prepayPercent: firstChoiceProram.prepayPercent,
            conversionFeePercent: firstChoiceProram.conversionFeePercent,
            conversionFeeMethod: firstChoiceProram.conversionFeeMethod,
            details: programs,
          });
        }
        /** Nếu đã chọn rồi thì find program đã chọn */
        const program = programs.find(
          (item) => item.id == this.getInstallmentProgram.installmentProgramId,
        );
        if (program) {
          return this.$store.dispatch(SET_INSTALLMENT_PROGRAM, {
            installmentProgramId: program.id,
            installmentProgramName: program.name,
            monthNo: program.monthNo,
            installmentProgramMonthNo: null,
            installmentProgramPrepayPercent:
              program.installmentProgramPrepayPercent,
            installmentProgramPrepayAmount: convertPrice(
              program.installmentProgramPrepayAmount || 0,
            ),
            prepayPercent: program.prepayPercent,
            conversionFeePercent: program.conversionFeePercent,
            conversionFeeMethod: program.conversionFeeMethod,
            details: programs,
          });
        }
      } else {
        this.$store.dispatch(PURGE_INSTALLMENT_PROGRAM);
      }
    },
    onShowInterestProgram() {
      this.$refs['bill-payment'].onLoading.interestZero = true;
      this.$nextTick(() => {
        EventBus.$emit('popup-insterest-program');
      });
    },
    searchFlexibleCombo(textSearch) {
      const params = {
        textSearch: textSearch,
        storeId: this.mainModel.storeId,
      };
      ApiService.query('flexible-combo/search', { params }).then(({ data }) => {
        const products = data.data;
        this.optionsProduct[0].data = products.map((product) =>
          Object.assign({}, new FlexibleComboSearchOption(product)),
        );
        this.filteredOptionsProduct = [
          {
            data: this.optionsProduct[0].data,
          },
        ];
        this.isSearching = false;
        this.productLoading = false;
      });
    },
    showModalFlexibleCombo() {
      setTimeout(() => {
        this.$refs['flexible-combo'].showModal();
      }, TIME_TRIGGER);
    },
    addComboChild(billItem) {
      billItem.id = v4();
      this.listBillItem.push(billItem);
      this.sortListBillItem(this.listBillItem);
    },
    combineFlexibleCombo(billItems) {
      const flexibleComboIds = uniq(
        billItems.map(
          (flexibleComboBillItem) => flexibleComboBillItem.flexibleComboId,
        ),
      );
      return flexibleComboIds.map((flexibleComboId) => {
        const flexibleComboItems = billItems.filter(
          (billItem) => billItem.flexibleComboId === flexibleComboId,
        );
        let comboName = '';
        if (flexibleComboItems.length) {
          comboName = flexibleComboItems[0].flexibleComboName;
        }
        const comboItems = flexibleComboItems.map((flexibleComboItem) => {
          return {
            id: flexibleComboItem.id,
            productCode: flexibleComboItem.productCode
              ? flexibleComboItem.productCode
              : '',
            productName: flexibleComboItem.productName
              ? flexibleComboItem.productName
              : '',
            quantity: flexibleComboItem.quantity,
            productId: flexibleComboItem.productId,
            productPrice: flexibleComboItem.productPrice
              ? flexibleComboItem.productPrice
              : 0,
            sellingPrice: flexibleComboItem.productPrice
              ? flexibleComboItem.productPrice
              : 0,
            productType: PRODUCT_TYPE.PRODUCT,
            discountAmount: flexibleComboItem.discountAmount,
            productComboPrice: 0,
            productComboRate: 0,
            productVatAmount: flexibleComboItem.productVatAmount,
            productNameVat: flexibleComboItem.productNameVat
              ? flexibleComboItem.productNameVat
              : '',
            listedPrice: flexibleComboItem.productPrice
              ? flexibleComboItem.productPrice
              : 0,
          };
        });
        const flexibleComboPrice = comboItems.reduce((result, product) => {
          result +=
            product.productPrice * product.quantity - product.discountAmount;
          return result;
        }, 0);
        return {
          id: flexibleComboId,
          productId: flexibleComboId,
          name: comboName,
          code: '',
          productNameVat: '',
          productNote: '',
          productType: PRODUCT_TYPE.PRODUCT_COMBO,
          quantity: 1,
          productPrice: flexibleComboPrice,
          imeiCode: '',
          totalPrice: flexibleComboPrice,
          discount: 0,
          discountType: AMOUNT_TYPE.PERCENT,
          comboItems: comboItems,
          billItemType: BILL_ITEM_TYPE.PRODUCT,
          checked: true,
          accessoryGroupId: null,
          accessoryGroupCode: '',
          repurchasePrice: 0,
          belongBillDetailId: null,
          note: '',
          listAccessoryPromotion: [],
          listProductPromotion: [],
          issuedVat: true,
          sellingPrice: flexibleComboPrice,
          price: flexibleComboPrice,
          listedPrice: flexibleComboPrice,
          flexibleComboId: flexibleComboId,
        };
      });
    },
    showAddVoucherModal(billItemId) {
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.productId = billItem.productId;
      this.selectedBillItem.productAmount = billItem.price;
      this.selectedBillItem.billItemId = billItemId;
      setTimeout(() => {
        this.$refs['apply-voucher-modal'].showModal();
      }, TIME_TRIGGER);
    },
    onApplyVoucherItem(voucherItem) {
      this.calVoucherCumluativeValue(voucherItem);
      this.$forceUpdate();
    },
    /**
     * Để hàm này lại có thể sẽ dùng để fix voucher đang không nhân với số lượng
     * @param voucherItem
     */
    // async calVoucherCumluativeValue(voucherItem) {
    //   const billItemSelected = this.listBillItem.find(
    //     (billItem) => billItem.id === this.selectedBillItem.billItemId,
    //   );
    //   billItemSelected.voucherCode = voucherItem.voucherCode;
    //   billItemSelected.voucherId = voucherItem.voucherId;
    //   billItemSelected.voucherDetailId = voucherItem.voucherDetailId;
    //   if (
    //     !voucherItem.cumluativeValues ||
    //     !voucherItem.cumluativeValues.length
    //   ) {
    //     billItemSelected.discountType = DISCOUNT_AMOUNT_TYPE.MONEY;
    //     billItemSelected.discountAmount =
    //       voucherItem.voucherValue &&
    //       voucherItem.voucherType === DISCOUNT_AMOUNT_TYPE.PERCENT
    //         ? voucherItem.voucherValue * billItemSelected.quantity
    //         : voucherItem.voucherValue;
    //     billItemSelected.discount =
    //       voucherItem.voucherValue &&
    //       voucherItem.voucherType === DISCOUNT_AMOUNT_TYPE.PERCENT
    //         ? voucherItem.voucherValue * billItemSelected.quantity
    //         : voucherItem.voucherValue;
    //     billItemSelected.voucherCumluativeValues = [];
    //     return;
    //   }
    //   this.reCalVoucherBillItem(voucherItem);
    //   this.customerDiscount = null;
    //   await this.fetchDiscountCustomerType();
    //   this.handlerDiscountCustomerType();
    // },
    // async calVoucherCumluativeValue(voucherItem) {
    //   const billItemSelected = this.listBillItem.find(
    //     (billItem) => billItem.id === this.selectedBillItem.billItemId,
    //   );
    //   billItemSelected.voucherCode = voucherItem.voucherCode;
    //   billItemSelected.voucherId = voucherItem.voucherId;
    //   billItemSelected.voucherDetailId = voucherItem.voucherDetailId;
    //   if (
    //     !voucherItem.cumluativeValues ||
    //     !voucherItem.cumluativeValues.length
    //   ) {
    //     billItemSelected.discountType = DISCOUNT_AMOUNT_TYPE.MONEY;
    //     billItemSelected.discountAmount = voucherItem.voucherValue;
    //     billItemSelected.discount = voucherItem.voucherValue;
    //     billItemSelected.voucherCumluativeValues = [];
    //     return;
    //   }
    //   this.reCalVoucherBillItem(voucherItem);
    //   await this.changeDiscountComponentCustomerInfo();
    // },
    async calVoucherCumluativeValue(voucherItem) {
      const billItemSelected = this.listBillItem.find(
        (billItem) => billItem.id === this.selectedBillItem.billItemId,
      );
      if (billItemSelected.vouchers.length > 4) {
        makeToastFaile('Không thể áp dụng trên 5 voucher cho 1 sản phẩm');
        return;
      }
      const validateVoucherExit = billItemSelected.vouchers.some(
        (voucher) => voucher.voucherId === voucherItem.voucherId,
      );
      if (validateVoucherExit) {
        makeToastFaile('Voucher đã được áp dụng cho sản phẩm');
        return;
      }
      billItemSelected.voucherCode = voucherItem.voucherCode;
      billItemSelected.voucherId = voucherItem.voucherId;
      billItemSelected.voucherDetailId = voucherItem.voucherDetailId;
      billItemSelected.vouchers.push({
        voucherId: voucherItem.voucherId,
        voucherTypeDiscount: DISCOUNT_AMOUNT_TYPE.MONEY,
        voucherAmount: voucherItem.voucherValue,
        voucherCode: voucherItem.voucherCode,
        voucherDetailId: voucherItem.voucherDetailId,
        cumluativeValues: voucherItem.cumluativeValues,
      });
      // trường hợp multiple nhiều voucher mà có chương trình là %
      // if (+billItemSelected.discountType === AMOUNT_TYPE.PERCENT) {
      //   let amount =
      //     billItemSelected.price * unMaskPrice(billItemSelected.discount);
      //   amount = (amount / 100).toFixed(0);
      //   billItemSelected.discount = amount;
      // }
      if (
        !voucherItem.cumluativeValues ||
        !voucherItem.cumluativeValues.length
      ) {
        billItemSelected.discountType = DISCOUNT_AMOUNT_TYPE.MONEY;
        billItemSelected.discountAmount =
          Number(unMaskPrice(billItemSelected.discountAmount)) +
          Number(unMaskPrice(voucherItem.voucherValue));
        billItemSelected.discount =
          Number(unMaskPrice(billItemSelected.discount)) +
          Number(unMaskPrice(voucherItem.voucherValue));
        billItemSelected.voucherCumluativeValues = [];
        if (
          billItemSelected.discount > billItemSelected.price ||
          billItemSelected.discountAmount > billItemSelected.price
        ) {
          billItemSelected.discount = billItemSelected.price;
          billItemSelected.discountAmount = billItemSelected.price;
        }
        return;
      }
      this.reCalVoucherBillItem(voucherItem);
      await this.changeDiscountComponentCustomerInfo();
    },
    handlerVoucher() {
      for (let i = 0; i < this.listBillItem.length; i++) {
        const billItem = this.listBillItem[i];
        // Capture tổng voucher GỐC (đã lưu trong DB / state) TRƯỚC khi oldReCalVoucher
        // mutate voucher.voucherAmount. Nếu cumulative tier không match qty hiện tại,
        // oldReCalVoucher sẽ overwrite voucherAmount về 0 — khi đó totalDiscountVoucher
        // sẽ trả 0, làm discountManual sai (gộp phần voucher vào manual). Hậu quả:
        // xoá voucher không trừ được tiền (discount giữ nguyên = manual sai + program).
        const originalVoucherSum = (billItem.vouchers || []).reduce(
          (sum, v) => sum + Number(v.voucherAmount || 0),
          0,
        );
        for (let j = 0; j < billItem.vouchers.length; j++) {
          const voucher = billItem.vouchers[j];
          const voucherItem = {
            billItemId: billItem.id,
            cumluativeValues:
              typeof voucher.cumluativeValues === 'object'
                ? voucher.cumluativeValues || []
                : JSON.parse(voucher.cumluativeValues || '[]'),
            voucherCode: voucher.voucherCode,
            voucherDetailId: voucher.voucherDetailId,
            voucherId: voucher.voucherId,
          };
          // voucher càng mua càng giảm
          if (
            voucherItem.cumluativeValues &&
            voucherItem.cumluativeValues.length
          ) {
            this.oldReCalVoucher(billItem, voucherItem);
          }
        }
        // Dùng originalVoucherSum (đã capture trước) thay vì recompute từ vouchers[]
        // đã bị mutate, để discountManual luôn = manual thật.
        billItem['discountManual'] =
          billItem.discount -
          originalVoucherSum -
          billItem.discountProgramAmount;
        billItem['discountManual'] =
          billItem['discountManual'] >= 0 ? billItem['discountManual'] : 0;
        // billItem['discount'] =
        //   billItem['discountManual'] +
        //   totalVoucherAmount +
        //   billItem.discountProgramAmount;
        // billItem['discountAmount'] =
        //   billItem['discountManual'] +
        //   totalVoucherAmount +
        //   billItem.discountProgramAmount;
      }
    },
    oldReCalVoucher(billItem, voucherItem) {
      const billItemVouchers = this.listBillItem.filter((billItem) =>
        billItem.vouchers.some(
          (voucher) => voucher.voucherId === voucherItem.voucherId,
        ),
      );
      const billItems = billItemVouchers.map((billItem) => {
        return {
          ...billItem,
          quantity: Number(billItem.quantity),
        };
      });
      const totalQuantity = sumBy(billItems, 'quantity');
      const typeValue = typeof voucherItem.cumluativeValues;
      let cumluativeValues =
        typeValue === 'string'
          ? JSON.parse(voucherItem.cumluativeValues || '[]')
          : voucherItem.cumluativeValues;
      if (!Array.isArray(cumluativeValues)) {
        cumluativeValues = [];
      }
      const cumluativeValueFound = cumluativeValues.find(
        (cumluativeValue) =>
          cumluativeValue.quantityFrom <= totalQuantity &&
          totalQuantity <= cumluativeValue.quantityTo,
      );
      const voucherCumluativeValue = cumluativeValueFound
        ? cumluativeValueFound.cumulativeValue
        : 0;
      // Chỉ lưu mốc cumulative hiện tại (oldVoucherCumluativeValue) để dùng làm delta
      // khi user thêm sản phẩm / đổi qty sau này (reCalVoucherBillItem dùng "discountVoucherOld").
      // KHÔNG mutate voucher.voucherAmount ở đây — nếu tier không match qty hiện tại (vd voucher
      // tier 2-2 mà bill đang chỉ có qty=1), mutate về 0 sẽ làm totalDiscountVoucher tính sai →
      // discountManual hấp thụ nhầm tiền voucher → xoá voucher không trừ được tiền.
      // Voucher.voucherAmount giữ giá trị đã lưu trong DB là nguồn truth cho discount đang hiển thị.
      billItem.oldVoucherCumluativeValue[voucherItem.voucherId] = {
        voucherId: voucherItem.voucherId,
        amount: Number(
          unMaskPrice(
            this.calVoucherValue(
              DISCOUNT_AMOUNT_TYPE.PERCENT,
              voucherCumluativeValue,
              billItem.price,
            ) * billItem.quantity,
          ),
        ),
      };
    },
    calVoucherValue(voucherType, voucherValue, productAmount) {
      if (voucherType === DISCOUNT_AMOUNT_TYPE.MONEY) {
        return voucherValue;
      }
      // Tiền VN không có số lẻ → làm tròn XUỐNG để tổng tiền giảm không vượt quá voucher
      // và tránh khách phải trả lẻ đồng. Floor ngay tại đây để mọi nơi gọi
      // calVoucherValue đều nhận giá trị nguyên (cộng/nhân với qty sau đó vẫn nguyên).
      return Math.floor((productAmount * voucherValue) / 100);
    },
    reCalVoucherBillItem(voucherItem) {
      const billItemVouchers = this.listBillItem.filter((billItem) =>
        billItem.vouchers.some(
          (voucher) => voucher.voucherId === voucherItem.voucherId,
        ),
      );
      // const billItems = billItemVouchers.map((billItem) => {
      //   return {
      //     ...billItem,
      //     quantity: Number(billItem.quantity),
      //   };
      // });
      // const totalQuantity = sumBy(billItems, 'quantity');
      const voucherCumluativeValue = this.calAmountVoucher(
        billItemVouchers,
        voucherItem,
      );
      for (const billItemVoucher of billItemVouchers) {
        billItemVoucher.oldVoucherCumluativeValue =
          billItemVoucher.oldVoucherCumluativeValue
            ? billItemVoucher.oldVoucherCumluativeValue
            : {};
        // lưu lại giá trị discount cũ để khi nếu add thêm sản phẩm chương trình càng mua càng giảm
        // sẽ trừ đi giá cũ tránh việc + thêm giá chiết khấu cũ
        const oldVoucherCumluativeValue =
          billItemVoucher.oldVoucherCumluativeValue;
        const discountVoucherOld = oldVoucherCumluativeValue[
          voucherItem.voucherId
        ]
          ? oldVoucherCumluativeValue[voucherItem.voucherId]['amount']
          : 0;
        // check xem tông chiết khấu có đang vượt giá trị sản phẩm không
        const discountManual = billItemVoucher.discountManual || 0;
        const discountProgramAmount =
          billItemVoucher.discountProgramAmount || 0;
        const discountVoucherAmount =
          this.totalDiscountVoucher(billItemVoucher);
        const discountOld =
          Number(discountManual) +
          Number(discountProgramAmount) +
          Number(discountVoucherAmount);
        billItemVoucher.discountAmount =
          Number(unMaskPrice(billItemVoucher.discount)) +
          Number(
            unMaskPrice(
              this.calVoucherValue(
                DISCOUNT_AMOUNT_TYPE.PERCENT,
                voucherCumluativeValue,
                billItemVoucher.price,
              ) * billItemVoucher.quantity,
            ),
          ) -
          (discountVoucherOld ? discountVoucherOld : 0);
        billItemVoucher.discount =
          Number(unMaskPrice(billItemVoucher.discount)) +
          Number(
            unMaskPrice(
              this.calVoucherValue(
                DISCOUNT_AMOUNT_TYPE.PERCENT,
                voucherCumluativeValue,
                billItemVoucher.price,
              ) * billItemVoucher.quantity,
            ),
          ) -
          (discountVoucherOld ? discountVoucherOld : 0);
        billItemVoucher.discountType = DISCOUNT_AMOUNT_TYPE.MONEY;
        billItemVoucher.voucherCumluativeValues = voucherItem.cumluativeValues;
        if (
          discountOld > billItemVoucher.price ||
          billItemVoucher.discount > billItemVoucher.price ||
          billItemVoucher.discountAmount > billItemVoucher.price
        ) {
          billItemVoucher.discount = billItemVoucher.price;
          billItemVoucher.discountAmount = billItemVoucher.price;
        }
        // lưu lại giá trị discount cũ để khi nếu add thêm sản phẩm chương trình càng mua càng giảm
        // sẽ trừ đi giá cũ tránh việc + thêm giá chiết khấu cũ
        // nếu billItem hết voucher thì chuyển thành {} luôn để tranh trường hợp âm
        billItemVoucher.oldVoucherCumluativeValue[voucherItem.voucherId] = {
          voucherId: voucherItem.voucherId,
          amount: Number(
            unMaskPrice(
              this.calVoucherValue(
                DISCOUNT_AMOUNT_TYPE.PERCENT,
                voucherCumluativeValue,
                billItemVoucher.price,
              ) * billItemVoucher.quantity,
            ),
          ),
        };
        const voucher = billItemVoucher.vouchers.filter(
          (voucher) => voucher.voucherId === voucherItem.voucherId,
        );
        voucher[0]['voucherTypeDiscount'] = 1;
        voucher[0]['voucherAmount'] = Number(
          unMaskPrice(
            this.calVoucherValue(
              DISCOUNT_AMOUNT_TYPE.PERCENT,
              voucherCumluativeValue,
              billItemVoucher.price,
            ) * billItemVoucher.quantity,
          ),
        );
      }
    },
    totalDiscountVoucher(billItem) {
      return billItem.vouchers.reduce((total, voucher) => {
        if (voucher.voucherTypeDiscount === 1) {
          // Nếu là loại chiết khấu tiền (amount)
          return total + voucher.voucherAmount;
        } else if (voucher.voucherTypeDiscount === 2) {
          let voucherAmount = voucher.voucherAmount;
          const typeCumluativeValues = typeof voucher.cumluativeValues;
          voucher.cumluativeValues =
            typeCumluativeValues === 'string'
              ? JSON.parse(voucher.cumluativeValues || '[]')
              : voucher.cumluativeValues;
          if (!Array.isArray(voucher.cumluativeValues)) {
            voucher.cumluativeValues = [];
          }
          if (voucher.cumluativeValues.length) {
            const billItemAddVoucher = this.listBillItem.filter((billItem) =>
              billItem.vouchers.some(
                (voucherInBill) =>
                  voucherInBill.voucherId === voucher.voucherId,
              ),
            );
            if (typeof voucher['cumluativeValues'] === 'string') {
              voucher['cumluativeValues'] = JSON.parse(
                voucher['cumluativeValues'] || '[]',
              );
            }
            voucherAmount = this.calAmountVoucher(billItemAddVoucher, voucher);
          }
          // Nếu là loại chiết khấu phần trăm (percent) — floor để tránh số lẻ tiền VN
          const percentDiscount = Math.floor((voucherAmount / 100) * billItem.price);
          return total + percentDiscount;
        }
        return total;
      }, 0);
    },
    calAmountVoucher(billItems, voucherItem) {
      const totalQuantity = sumBy(
        billItems,
        (item) => Number(item.quantity) || 0,
      );
      const typeValue = typeof voucherItem.cumluativeValues;
      let cumluativeValues =
        typeValue === 'string'
          ? JSON.parse(voucherItem.cumluativeValues || '[]')
          : voucherItem.cumluativeValues;
      if (!Array.isArray(cumluativeValues)) {
        cumluativeValues = [];
      }
      const cumluativeValueFound = cumluativeValues.find(
        (cumluativeValue) =>
          cumluativeValue.quantityFrom <= totalQuantity &&
          totalQuantity <= cumluativeValue.quantityTo,
      );
      const voucherCumluativeValue = cumluativeValueFound
        ? cumluativeValueFound.cumulativeValue
        : 0;
      return voucherCumluativeValue;
    },
    // reCalVoucherBillItem(voucherItem) {
    //   const billItemVouchers = this.listBillItem.filter(
    //     (billItem) => billItem.voucherId === voucherItem.voucherId,
    //   );
    //   const billItems = billItemVouchers.map((billItem) => {
    //     return {
    //       ...billItem,
    //       quantity: Number(billItem.quantity),
    //     };
    //   });
    //   const totalQuantity = sumBy(billItems, 'quantity');
    //   const cumluativeValueFound = voucherItem.cumluativeValues.find(
    //     (cumluativeValue) =>
    //       cumluativeValue.quantityFrom <= totalQuantity &&
    //       totalQuantity <= cumluativeValue.quantityTo,
    //   );
    //   const voucherCumluativeValue = cumluativeValueFound
    //     ? cumluativeValueFound.cumulativeValue
    //     : 0;
    //   for (const billItemVoucher of billItemVouchers) {
    //     billItemVoucher.discountAmount =
    //       this.calVoucherValue(
    //         DISCOUNT_AMOUNT_TYPE.PERCENT,
    //         voucherCumluativeValue,
    //         billItemVoucher.price,
    //       ) * billItemVoucher.quantity;
    //     billItemVoucher.discount =
    //       this.calVoucherValue(
    //         DISCOUNT_AMOUNT_TYPE.PERCENT,
    //         voucherCumluativeValue,
    //         billItemVoucher.price,
    //       ) * billItemVoucher.quantity;
    //     billItemVoucher.discountType = DISCOUNT_AMOUNT_TYPE.MONEY;
    //     billItemVoucher.voucherCumluativeValues = voucherItem.cumluativeValues;
    //   }
    // },
    handleRemainAmountChanged(remainAmount) {
      this.remainAmount = remainAmount;
    },
    checkIfContainsSoftwareProducts() {
      for (const element of this.listBillItem) {
        if ('isSoftwareProduct' in element) {
          if (element.isSoftwareProduct && this.remainAmount <= 0) {
            this.isEnableSendBillMethod = true;
            return;
          }
        }
        this.isEnableSendBillMethod = false;
      }
    },
    checkIfContainsPartnerProducts() {
      let hasSoftwareProduct = false;
      let hasVieonProduct = false;
      for (const element of this.listBillItem) {
        if ('isSoftwareProduct' in element && element.isSoftwareProduct) {
          hasSoftwareProduct = true;
        }
        if ('isVieonProduct' in element && element.isVieonProduct) {
          hasVieonProduct = true;
        }
        // Nếu điều kiện remainAmount <= 0 và có isSoftwareProduct hoặc isVieonProduct
        if ((hasSoftwareProduct || hasVieonProduct) && this.remainAmount <= 0) {
          this.isEnableSendBillMethod = true;
          return;
        }
      }
      // Nếu không thỏa mãn điều kiện nào, tắt phương thức gửi hóa đơn
      this.isEnableSendBillMethod = false;
    },
    /* Gọi api khởi tạo giao dịch Kredivo và generate QR tải app Kredivo */
    generateQRCodeKredivo: async function (payment) {
      if (isValidUUID(payment.id)) {
        /* ID là UUID chưa có dưới DB => Tạo payment để có paymentID */
        const paymentWithoutId = omit(payment, ['id', 'child']);
        const payloadPayment = {
          ...paymentWithoutId,
          entityRefId: this.mainModel.billNumber,
          entityRefType: PAYMENT_ENTITY_TYPE.BILL,
        };
        const paymentResponse = await ApiService.post(
          `/payments`,
          payloadPayment,
        );
        payment.id = paymentResponse.data.data.id;
        await this.getBillByIdAndReRenderBillPayment();
      }
      const data = {
        paymentId: payment.id,
        orderId: this.mainModel.id,
        billNumber: this.mainModel.billNumber,
        storeShortName: this.mainModel.storeShortName,
        amount: payment.paymentAmount,
        customer: this.mainModel.customerModel,
        products: this.listBillItem,
      };
      try {
        const response = await ApiService.post(
          `/installments/kredivo/checkout-init/${payment.id}`,
          data,
        );
        payment.pendingTransactionId = response.data.data.pendingTransactionId;
        payment.pendingTransactionStatus = PAYMENT_TRANSACTION_STATUS.INITIAL;
        this.mainModel.installments = this.mainModel.installments.map(
          (installment) =>
            installment.id === payment.id ? payment : installment,
        );
        this.reRenderComponentBillPayment++;
        return this.$refs['qr-code-kredivo-modal'].showModal(
          payment,
          response.data.data.qrLink,
        );
      } catch (err) {
        const errorMessage = err.response
          ? err.response.data.message
          : 'Lỗi mạng!';
        return this.showAlert('Không thành công', errorMessage, 'error');
      }
    },
    validateMultipleEmailCustomer(emails) {
      if (!emails?.trim()) return true;
      const customerEmail = emails.split(';')[0].trim();
      if (!isValidEmail(customerEmail)) {
        makeToastFaile(`Email ${customerEmail} không đúng định dạng!`);
        return false;
      }
      return true;
    },
  },
};
</script>

<style>
.autosuggest__results {
  position: absolute;
  width: 100%;
  max-height: 200px;
  border: 1px solid #e0e0e0;
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: #fff;
}

.autosuggest__results-container {
  position: relative;
  font-weight: 500;
  width: 100%;
}

.autosuggest__input {
  display: block;
  width: 100%;
  height: calc(1.35em + 1.1rem + 2px);
  line-height: 1.35;
  padding: 0.55rem 0.75rem;
  font-weight: 400;
  font-size: 0.925rem;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.28rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.autosuggest__input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

.autosuggest__results-item:hover {
  background-color: #ddd;
}

.autosuggest__results ul li {
  padding: 5px 8px 5px 8px;
}

::-webkit-scrollbar {
  width: 13px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 3px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbbf;
}
</style>

<style lang="scss">
.bill-info {
  .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
    flex: 0 0 calc(15% - 0.25rem);
  }

  @media (max-width: 1399.98px) {
    .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
      flex: 0 0 calc(17% - 0.25rem);
    }
  }

  .wizard-nav-bg {
    background-color: #f7f7f7;
    border-radius: 5px 5px 0px 0px;
  }

  .alert-header {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }

  .box {
    background: black;
    border-radius: 4px;
    padding-bottom: 100%;
  }

  .headerTable {
    color: rgb(24, 28, 50);
    text-align: center;
  }

  .form-group label {
    font-weight: 500;
  }

  .textExcessCash {
    font-weight: 500;
    color: rgba(71, 71, 255, 0.87);
  }

  .row-center-vertical {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .textPoint {
    font-size: 14px;
    font-weight: 500;
  }

  .textFinal {
    font-weight: 500;
    color: brown;
  }

  .textTitlePayment {
    font-weight: 500;
    font-size: 14px;
  }

  .textPayment {
    font-size: 16px;
    font-weight: 500;
    color: brown;
  }

  .no-side {
    padding-left: 0px;
    padding-right: 0px;
  }

  .dropdown-custom {
    .btn-sm,
    .btn-group-sm > .btn {
      padding: 1px 2px;
      background-color: transparent;
      border: none;
      border-radius: 3px;
    }
  }
}
</style>

<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>

<style lang="scss">
.upload-file {
  table {
    table-layout: fixed;
  }

  .dropbox {
    margin: auto;
    width: 70%;
    background: #f8f8f8;
    border-radius: 20px;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    left: 0px;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: #e8f5e9;
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }

  .img-container {
    position: relative;
    display: inline-block;
    width: 80px;
    margin: 0px 10px;
  }

  .preview-img {
    max-width: 80px;
    padding: 10px;
    object-fit: contain;
    border: 1px solid #eeecff;
    border-radius: 5px;
  }

  .preview-img-container {
    border: 2px dashed #eeecff;
    padding: 2rem 1rem;
  }

  .preview-box {
    display: inline-block;
  }

  .close {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 15px;
  }

  .remove {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 15px;
  }

  .cancel {
    color: #545454;
    text-decoration: none;
  }
}
</style>
